/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TimelineRouteImport } from './routes/timeline'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StreamsRouteImport } from './routes/streams'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RsvpRouteImport } from './routes/rsvp'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlanRouteImport } from './routes/plan'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as MyWorkRouteImport } from './routes/my-work'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as EventsRouteImport } from './routes/events'
import { Route as DiagnosticAdminRouteImport } from './routes/diagnostic-admin'
import { Route as DiagnosticRouteImport } from './routes/diagnostic'
import { Route as DataDeletionRouteImport } from './routes/data-deletion'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as Access_matrixRouteImport } from './routes/access_matrix'
import { Route as HermesRouteRouteImport } from './routes/hermes/route'
import { Route as FinanceRouteRouteImport } from './routes/finance/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TrackingIndexRouteImport } from './routes/tracking/index'
import { Route as TeamIndexRouteImport } from './routes/team/index'
import { Route as StrategyIndexRouteImport } from './routes/strategy/index'
import { Route as RecordingsIndexRouteImport } from './routes/recordings/index'
import { Route as OperationsIndexRouteImport } from './routes/operations/index'
import { Route as MarketingIndexRouteImport } from './routes/marketing/index'
import { Route as LearnIndexRouteImport } from './routes/learn/index'
import { Route as HermesIndexRouteImport } from './routes/hermes/index'
import { Route as FinanceIndexRouteImport } from './routes/finance/index'
import { Route as EventsIndexRouteImport } from './routes/events/index'
import { Route as DiagnosticsIndexRouteImport } from './routes/diagnostics/index'
import { Route as DiagnosticIndexRouteImport } from './routes/diagnostic.index'
import { Route as CrmIndexRouteImport } from './routes/crm/index'
import { Route as CommunityIndexRouteImport } from './routes/community/index'
import { Route as CoachingIndexRouteImport } from './routes/coaching/index'
import { Route as ChatIndexRouteImport } from './routes/chat/index'
import { Route as AuthorIndexRouteImport } from './routes/author/index'
import { Route as AssetsIndexRouteImport } from './routes/assets/index'
import { Route as AlfieIndexRouteImport } from './routes/alfie/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as TrackingReportsRouteImport } from './routes/tracking/reports'
import { Route as TrackingLeadLagRouteImport } from './routes/tracking/lead-lag'
import { Route as TeamSkillsRouteImport } from './routes/team/skills'
import { Route as TeamRolesRouteImport } from './routes/team/roles'
import { Route as TeamHrRouteImport } from './routes/team/hr'
import { Route as TeamDirectoryRouteImport } from './routes/team/directory'
import { Route as TeamCultureRouteImport } from './routes/team/culture'
import { Route as StrategyBusinessPlanRouteImport } from './routes/strategy/business-plan'
import { Route as StrategyArchitectureRouteImport } from './routes/strategy/architecture'
import { Route as RecordingRecordingIdRouteImport } from './routes/recording.$recordingId'
import { Route as OrgSlugRouteImport } from './routes/org.$slug'
import { Route as OperationsSystemsRouteImport } from './routes/operations/systems'
import { Route as OperationsPoliciesRouteImport } from './routes/operations/policies'
import { Route as OperationsComplianceRouteImport } from './routes/operations/compliance'
import { Route as MastermindMastermindIdRouteImport } from './routes/mastermind.$mastermindId'
import { Route as MarketingSocialRouteImport } from './routes/marketing/social'
import { Route as MarketingSalesRouteImport } from './routes/marketing/sales'
import { Route as MarketingContentRouteImport } from './routes/marketing/content'
import { Route as LearnGamifiedRouteImport } from './routes/learn/gamified'
import { Route as InvitationsAcceptRouteImport } from './routes/invitations.accept'
import { Route as HermesExecutionsRouteImport } from './routes/hermes/executions'
import { Route as HermesDlqRouteImport } from './routes/hermes/dlq'
import { Route as HermesDefinitionsRouteImport } from './routes/hermes/definitions'
import { Route as HermesBuilderRouteImport } from './routes/hermes/builder'
import { Route as FinanceScorecardRouteImport } from './routes/finance/scorecard'
import { Route as FinanceScenariosRouteImport } from './routes/finance/scenarios'
import { Route as FinanceReportsRouteImport } from './routes/finance/reports'
import { Route as FinanceProfitRouteImport } from './routes/finance/profit'
import { Route as FinanceForecastRouteImport } from './routes/finance/forecast'
import { Route as FinanceDataRouteImport } from './routes/finance/data'
import { Route as FinanceDashboardsRouteImport } from './routes/finance/dashboards'
import { Route as FinanceCashflowRouteImport } from './routes/finance/cashflow'
import { Route as FinanceBudgetRouteImport } from './routes/finance/budget'
import { Route as EventsEventIdRouteImport } from './routes/events/$eventId'
import { Route as DiagnosticsPrimePathRouteImport } from './routes/diagnostics/prime-path'
import { Route as DiagnosticsLeadershipRouteImport } from './routes/diagnostics/leadership'
import { Route as DiagnosticsGapAnalysisRouteImport } from './routes/diagnostics/gap-analysis'
import { Route as DiagnosticRoadmapRouteImport } from './routes/diagnostic.roadmap'
import { Route as DiagnosticResultsRouteImport } from './routes/diagnostic.results'
import { Route as DiagnosticHistoryRouteImport } from './routes/diagnostic.history'
import { Route as CrmProjectsRouteImport } from './routes/crm/projects'
import { Route as CrmDealsRouteImport } from './routes/crm/deals'
import { Route as CrmContactsRouteImport } from './routes/crm/contacts'
import { Route as CommunityLeaderboardRouteImport } from './routes/community/leaderboard'
import { Route as CoachingDirectoryRouteImport } from './routes/coaching/directory'
import { Route as CoachingBookRouteImport } from './routes/coaching/book'
import { Route as AuthConfirmRouteImport } from './routes/auth.confirm'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AssetsTemplatesRouteImport } from './routes/assets/templates'
import { Route as AssetsAppsRouteImport } from './routes/assets/apps'
import { Route as ApiDocsRouteImport } from './routes/api.docs'
import { Route as AlfieSettingsRouteImport } from './routes/alfie/settings'
import { Route as AlfieInsightsRouteImport } from './routes/alfie/insights'
import { Route as AlfieAgentRouteImport } from './routes/alfie/agent'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTierSettingsRouteImport } from './routes/admin/tier-settings'
import { Route as AdminSurveysRouteImport } from './routes/admin/surveys'
import { Route as AdminSubscriptionsRouteImport } from './routes/admin/subscriptions'
import { Route as AdminSpeediesRouteImport } from './routes/admin/speedies'
import { Route as AdminSignupCodesRouteImport } from './routes/admin/signup-codes'
import { Route as AdminSecurityRouteImport } from './routes/admin/security'
import { Route as AdminSalesRouteImport } from './routes/admin/sales'
import { Route as AdminRevenueRouteImport } from './routes/admin/revenue'
import { Route as AdminPushDiagnosticsRouteImport } from './routes/admin/push-diagnostics'
import { Route as AdminOnboardingQuestionsRouteImport } from './routes/admin/onboarding-questions'
import { Route as AdminMentorshipRouteImport } from './routes/admin/mentorship'
import { Route as AdminIntegrationsRouteImport } from './routes/admin/integrations'
import { Route as AdminImportSyncRouteImport } from './routes/admin/import-sync'
import { Route as AdminFreeCoursesRouteImport } from './routes/admin/free-courses'
import { Route as AdminFlagsRouteImport } from './routes/admin/flags'
import { Route as AdminEventPurchasesRouteImport } from './routes/admin/event-purchases'
import { Route as AdminDeveloperRouteImport } from './routes/admin/developer'
import { Route as AdminCommunitiesRouteImport } from './routes/admin/communities'
import { Route as AdminAvatarCheckRouteImport } from './routes/admin/avatar-check'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminAllowedSignupsRouteImport } from './routes/admin/allowed-signups'
import { Route as AdminAiUsageRouteImport } from './routes/admin/ai-usage'
import { Route as AdminAccessRequestsRouteImport } from './routes/admin/access-requests'
import { Route as AdminAccessRouteImport } from './routes/admin/access'
import { Route as LearnCoursesIndexRouteImport } from './routes/learn/courses.index'
import { Route as LearnCertificatesIndexRouteImport } from './routes/learn/certificates/index'
import { Route as AssetsAssetIdIndexRouteImport } from './routes/assets/$assetId.index'
import { Route as RecordingsSourceIdRouteImport } from './routes/recordings/$source.$id'
import { Route as LearnPathsPathIdRouteImport } from './routes/learn/paths/$pathId'
import { Route as LearnCoursesCourseIdRouteImport } from './routes/learn/courses/$courseId'
import { Route as LearnAssessmentsAssessmentIdRouteImport } from './routes/learn/assessments/$assessmentId'
import { Route as HermesExecutionsExecutionIdRouteImport } from './routes/hermes/executions_.$executionId'
import { Route as FinanceXeroMappingRouteImport } from './routes/finance/xero.mapping'
import { Route as FinanceXeroConnectRouteImport } from './routes/finance/xero.connect'
import { Route as FinanceForecastWhatIfScenariosRouteImport } from './routes/finance/forecast_.what-if-scenarios'
import { Route as FinanceForecastStaffMixRouteImport } from './routes/finance/forecast_.staff-mix'
import { Route as FinanceForecastProjectPricingRouteImport } from './routes/finance/forecast_.project-pricing'
import { Route as FinanceForecastProfitFirstRouteImport } from './routes/finance/forecast_.profit-first'
import { Route as FinanceForecastOverheadRecoveryRouteImport } from './routes/finance/forecast_.overhead-recovery'
import { Route as FinanceForecastGpPerHourRouteImport } from './routes/finance/forecast_.gp-per-hour'
import { Route as FinanceForecastFinancialFreedomRouteImport } from './routes/finance/forecast_.financial-freedom'
import { Route as FinanceForecastBudgetVsActualRouteImport } from './routes/finance/forecast_.budget-vs-actual'
import { Route as FinanceForecast13WeekCashflowRouteImport } from './routes/finance/forecast_.13-week-cashflow'
import { Route as FinanceForecast12MonthPlRouteImport } from './routes/finance/forecast_.12-month-pl'
import { Route as FinanceDashboardsDashboardIdRouteImport } from './routes/finance/dashboards_.$dashboardId'
import { Route as CommunityPostPostIdRouteImport } from './routes/community/post.$postId'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users_.$userId'
import { Route as AdminSignupCodesCodeRouteImport } from './routes/admin/signup-codes_.$code'
import { Route as AdminDiagnosticSettingsRouteImport } from './routes/admin.diagnostic.settings'
import { Route as AdminDiagnosticQuestionsRouteImport } from './routes/admin.diagnostic.questions'
import { Route as AdminDiagnosticInspectRouteImport } from './routes/admin.diagnostic.inspect'
import { Route as AdminDiagnosticImportExportRouteImport } from './routes/admin.diagnostic.import-export'
import { Route as AdminDiagnosticGuardrailsRouteImport } from './routes/admin.diagnostic.guardrails'
import { Route as AdminCommunitiesNewRouteImport } from './routes/admin/communities_.new'
import { Route as AdminCommunitiesCommunityIdRouteImport } from './routes/admin/communities_.$communityId'
import { Route as LearnCoursesCourseIdIndexRouteImport } from './routes/learn/courses/$courseId.index'
import { Route as AuthorCoursesCourseIdEditRouteImport } from './routes/author/courses/$courseId/edit'
import { Route as AuthorAssessmentsAssessmentIdEditRouteImport } from './routes/author/assessments/$assessmentId/edit'
import { Route as AdminDiagnosticQuestionsIdRouteImport } from './routes/admin.diagnostic.questions.$id'
import { Route as LearnCoursesCourseIdLessonsLessonIdRouteImport } from './routes/learn/courses/$courseId/lessons/$lessonId'
import { Route as AdminDiagnosticQuestionsIdTestRouteImport } from './routes/admin.diagnostic.questions.$id.test'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const TimelineRoute = TimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StreamsRoute = StreamsRouteImport.update({
  id: '/streams',
  path: '/streams',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RsvpRoute = RsvpRouteImport.update({
  id: '/rsvp',
  path: '/rsvp',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanRoute = PlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const MyWorkRoute = MyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnosticAdminRoute = DiagnosticAdminRouteImport.update({
  id: '/diagnostic-admin',
  path: '/diagnostic-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnosticRoute = DiagnosticRouteImport.update({
  id: '/diagnostic',
  path: '/diagnostic',
  getParentRoute: () => rootRouteImport,
} as any)
const DataDeletionRoute = DataDeletionRouteImport.update({
  id: '/data-deletion',
  path: '/data-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const Access_matrixRoute = Access_matrixRouteImport.update({
  id: '/access_matrix',
  path: '/access_matrix',
  getParentRoute: () => rootRouteImport,
} as any)
const HermesRouteRoute = HermesRouteRouteImport.update({
  id: '/hermes',
  path: '/hermes',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRouteRoute = FinanceRouteRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackingIndexRoute = TrackingIndexRouteImport.update({
  id: '/tracking/',
  path: '/tracking/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamIndexRoute = TeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategyIndexRoute = StrategyIndexRouteImport.update({
  id: '/strategy/',
  path: '/strategy/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsIndexRoute = RecordingsIndexRouteImport.update({
  id: '/recordings/',
  path: '/recordings/',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsIndexRoute = OperationsIndexRouteImport.update({
  id: '/operations/',
  path: '/operations/',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/marketing/',
  path: '/marketing/',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnIndexRoute = LearnIndexRouteImport.update({
  id: '/learn/',
  path: '/learn/',
  getParentRoute: () => rootRouteImport,
} as any)
const HermesIndexRoute = HermesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HermesRouteRoute,
} as any)
const FinanceIndexRoute = FinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventsRoute,
} as any)
const DiagnosticsIndexRoute = DiagnosticsIndexRouteImport.update({
  id: '/diagnostics/',
  path: '/diagnostics/',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnosticIndexRoute = DiagnosticIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DiagnosticRoute,
} as any)
const CrmIndexRoute = CrmIndexRouteImport.update({
  id: '/crm/',
  path: '/crm/',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityIndexRoute = CommunityIndexRouteImport.update({
  id: '/community/',
  path: '/community/',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachingIndexRoute = CoachingIndexRouteImport.update({
  id: '/coaching/',
  path: '/coaching/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthorIndexRoute = AuthorIndexRouteImport.update({
  id: '/author/',
  path: '/author/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsIndexRoute = AssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => rootRouteImport,
} as any)
const AlfieIndexRoute = AlfieIndexRouteImport.update({
  id: '/alfie/',
  path: '/alfie/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const TrackingReportsRoute = TrackingReportsRouteImport.update({
  id: '/tracking/reports',
  path: '/tracking/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackingLeadLagRoute = TrackingLeadLagRouteImport.update({
  id: '/tracking/lead-lag',
  path: '/tracking/lead-lag',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamSkillsRoute = TeamSkillsRouteImport.update({
  id: '/team/skills',
  path: '/team/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRolesRoute = TeamRolesRouteImport.update({
  id: '/team/roles',
  path: '/team/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamHrRoute = TeamHrRouteImport.update({
  id: '/team/hr',
  path: '/team/hr',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamDirectoryRoute = TeamDirectoryRouteImport.update({
  id: '/team/directory',
  path: '/team/directory',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamCultureRoute = TeamCultureRouteImport.update({
  id: '/team/culture',
  path: '/team/culture',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategyBusinessPlanRoute = StrategyBusinessPlanRouteImport.update({
  id: '/strategy/business-plan',
  path: '/strategy/business-plan',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategyArchitectureRoute = StrategyArchitectureRouteImport.update({
  id: '/strategy/architecture',
  path: '/strategy/architecture',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingRecordingIdRoute = RecordingRecordingIdRouteImport.update({
  id: '/recording/$recordingId',
  path: '/recording/$recordingId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSlugRoute = OrgSlugRouteImport.update({
  id: '/org/$slug',
  path: '/org/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsSystemsRoute = OperationsSystemsRouteImport.update({
  id: '/operations/systems',
  path: '/operations/systems',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsPoliciesRoute = OperationsPoliciesRouteImport.update({
  id: '/operations/policies',
  path: '/operations/policies',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsComplianceRoute = OperationsComplianceRouteImport.update({
  id: '/operations/compliance',
  path: '/operations/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const MastermindMastermindIdRoute = MastermindMastermindIdRouteImport.update({
  id: '/mastermind/$mastermindId',
  path: '/mastermind/$mastermindId',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingSocialRoute = MarketingSocialRouteImport.update({
  id: '/marketing/social',
  path: '/marketing/social',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingSalesRoute = MarketingSalesRouteImport.update({
  id: '/marketing/sales',
  path: '/marketing/sales',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingContentRoute = MarketingContentRouteImport.update({
  id: '/marketing/content',
  path: '/marketing/content',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnGamifiedRoute = LearnGamifiedRouteImport.update({
  id: '/learn/gamified',
  path: '/learn/gamified',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
  id: '/invitations/accept',
  path: '/invitations/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const HermesExecutionsRoute = HermesExecutionsRouteImport.update({
  id: '/executions',
  path: '/executions',
  getParentRoute: () => HermesRouteRoute,
} as any)
const HermesDlqRoute = HermesDlqRouteImport.update({
  id: '/dlq',
  path: '/dlq',
  getParentRoute: () => HermesRouteRoute,
} as any)
const HermesDefinitionsRoute = HermesDefinitionsRouteImport.update({
  id: '/definitions',
  path: '/definitions',
  getParentRoute: () => HermesRouteRoute,
} as any)
const HermesBuilderRoute = HermesBuilderRouteImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => HermesRouteRoute,
} as any)
const FinanceScorecardRoute = FinanceScorecardRouteImport.update({
  id: '/scorecard',
  path: '/scorecard',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceScenariosRoute = FinanceScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceReportsRoute = FinanceReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceProfitRoute = FinanceProfitRouteImport.update({
  id: '/profit',
  path: '/profit',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceForecastRoute = FinanceForecastRouteImport.update({
  id: '/forecast',
  path: '/forecast',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceDataRoute = FinanceDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceDashboardsRoute = FinanceDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceCashflowRoute = FinanceCashflowRouteImport.update({
  id: '/cashflow',
  path: '/cashflow',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceBudgetRoute = FinanceBudgetRouteImport.update({
  id: '/budget',
  path: '/budget',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => EventsRoute,
} as any)
const DiagnosticsPrimePathRoute = DiagnosticsPrimePathRouteImport.update({
  id: '/diagnostics/prime-path',
  path: '/diagnostics/prime-path',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnosticsLeadershipRoute = DiagnosticsLeadershipRouteImport.update({
  id: '/diagnostics/leadership',
  path: '/diagnostics/leadership',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnosticsGapAnalysisRoute = DiagnosticsGapAnalysisRouteImport.update({
  id: '/diagnostics/gap-analysis',
  path: '/diagnostics/gap-analysis',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnosticRoadmapRoute = DiagnosticRoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => DiagnosticRoute,
} as any)
const DiagnosticResultsRoute = DiagnosticResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => DiagnosticRoute,
} as any)
const DiagnosticHistoryRoute = DiagnosticHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => DiagnosticRoute,
} as any)
const CrmProjectsRoute = CrmProjectsRouteImport.update({
  id: '/crm/projects',
  path: '/crm/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmDealsRoute = CrmDealsRouteImport.update({
  id: '/crm/deals',
  path: '/crm/deals',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmContactsRoute = CrmContactsRouteImport.update({
  id: '/crm/contacts',
  path: '/crm/contacts',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityLeaderboardRoute = CommunityLeaderboardRouteImport.update({
  id: '/community/leaderboard',
  path: '/community/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachingDirectoryRoute = CoachingDirectoryRouteImport.update({
  id: '/coaching/directory',
  path: '/coaching/directory',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachingBookRoute = CoachingBookRouteImport.update({
  id: '/coaching/book',
  path: '/coaching/book',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthConfirmRoute = AuthConfirmRouteImport.update({
  id: '/auth/confirm',
  path: '/auth/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsTemplatesRoute = AssetsTemplatesRouteImport.update({
  id: '/assets/templates',
  path: '/assets/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsAppsRoute = AssetsAppsRouteImport.update({
  id: '/assets/apps',
  path: '/assets/apps',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiDocsRoute = ApiDocsRouteImport.update({
  id: '/api/docs',
  path: '/api/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AlfieSettingsRoute = AlfieSettingsRouteImport.update({
  id: '/alfie/settings',
  path: '/alfie/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AlfieInsightsRoute = AlfieInsightsRouteImport.update({
  id: '/alfie/insights',
  path: '/alfie/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const AlfieAgentRoute = AlfieAgentRouteImport.update({
  id: '/alfie/agent',
  path: '/alfie/agent',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTierSettingsRoute = AdminTierSettingsRouteImport.update({
  id: '/tier-settings',
  path: '/tier-settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSurveysRoute = AdminSurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSubscriptionsRoute = AdminSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSpeediesRoute = AdminSpeediesRouteImport.update({
  id: '/speedies',
  path: '/speedies',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSignupCodesRoute = AdminSignupCodesRouteImport.update({
  id: '/signup-codes',
  path: '/signup-codes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSecurityRoute = AdminSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSalesRoute = AdminSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRevenueRoute = AdminRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPushDiagnosticsRoute = AdminPushDiagnosticsRouteImport.update({
  id: '/push-diagnostics',
  path: '/push-diagnostics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnboardingQuestionsRoute =
  AdminOnboardingQuestionsRouteImport.update({
    id: '/onboarding-questions',
    path: '/onboarding-questions',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminMentorshipRoute = AdminMentorshipRouteImport.update({
  id: '/mentorship',
  path: '/mentorship',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegrationsRoute = AdminIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminImportSyncRoute = AdminImportSyncRouteImport.update({
  id: '/import-sync',
  path: '/import-sync',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFreeCoursesRoute = AdminFreeCoursesRouteImport.update({
  id: '/free-courses',
  path: '/free-courses',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFlagsRoute = AdminFlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventPurchasesRoute = AdminEventPurchasesRouteImport.update({
  id: '/event-purchases',
  path: '/event-purchases',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeveloperRoute = AdminDeveloperRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCommunitiesRoute = AdminCommunitiesRouteImport.update({
  id: '/communities',
  path: '/communities',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAvatarCheckRoute = AdminAvatarCheckRouteImport.update({
  id: '/avatar-check',
  path: '/avatar-check',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAllowedSignupsRoute = AdminAllowedSignupsRouteImport.update({
  id: '/allowed-signups',
  path: '/allowed-signups',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiUsageRoute = AdminAiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAccessRequestsRoute = AdminAccessRequestsRouteImport.update({
  id: '/access-requests',
  path: '/access-requests',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAccessRoute = AdminAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AdminRoute,
} as any)
const LearnCoursesIndexRoute = LearnCoursesIndexRouteImport.update({
  id: '/learn/courses/',
  path: '/learn/courses/',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnCertificatesIndexRoute = LearnCertificatesIndexRouteImport.update({
  id: '/learn/certificates/',
  path: '/learn/certificates/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsAssetIdIndexRoute = AssetsAssetIdIndexRouteImport.update({
  id: '/assets/$assetId/',
  path: '/assets/$assetId/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsSourceIdRoute = RecordingsSourceIdRouteImport.update({
  id: '/recordings/$source/$id',
  path: '/recordings/$source/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnPathsPathIdRoute = LearnPathsPathIdRouteImport.update({
  id: '/learn/paths/$pathId',
  path: '/learn/paths/$pathId',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnCoursesCourseIdRoute = LearnCoursesCourseIdRouteImport.update({
  id: '/learn/courses/$courseId',
  path: '/learn/courses/$courseId',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnAssessmentsAssessmentIdRoute =
  LearnAssessmentsAssessmentIdRouteImport.update({
    id: '/learn/assessments/$assessmentId',
    path: '/learn/assessments/$assessmentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const HermesExecutionsExecutionIdRoute =
  HermesExecutionsExecutionIdRouteImport.update({
    id: '/executions_/$executionId',
    path: '/executions/$executionId',
    getParentRoute: () => HermesRouteRoute,
  } as any)
const FinanceXeroMappingRoute = FinanceXeroMappingRouteImport.update({
  id: '/xero/mapping',
  path: '/xero/mapping',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceXeroConnectRoute = FinanceXeroConnectRouteImport.update({
  id: '/xero/connect',
  path: '/xero/connect',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceForecastWhatIfScenariosRoute =
  FinanceForecastWhatIfScenariosRouteImport.update({
    id: '/forecast_/what-if-scenarios',
    path: '/forecast/what-if-scenarios',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceForecastStaffMixRoute = FinanceForecastStaffMixRouteImport.update({
  id: '/forecast_/staff-mix',
  path: '/forecast/staff-mix',
  getParentRoute: () => FinanceRouteRoute,
} as any)
const FinanceForecastProjectPricingRoute =
  FinanceForecastProjectPricingRouteImport.update({
    id: '/forecast_/project-pricing',
    path: '/forecast/project-pricing',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceForecastProfitFirstRoute =
  FinanceForecastProfitFirstRouteImport.update({
    id: '/forecast_/profit-first',
    path: '/forecast/profit-first',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceForecastOverheadRecoveryRoute =
  FinanceForecastOverheadRecoveryRouteImport.update({
    id: '/forecast_/overhead-recovery',
    path: '/forecast/overhead-recovery',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceForecastGpPerHourRoute =
  FinanceForecastGpPerHourRouteImport.update({
    id: '/forecast_/gp-per-hour',
    path: '/forecast/gp-per-hour',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceForecastFinancialFreedomRoute =
  FinanceForecastFinancialFreedomRouteImport.update({
    id: '/forecast_/financial-freedom',
    path: '/forecast/financial-freedom',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceForecastBudgetVsActualRoute =
  FinanceForecastBudgetVsActualRouteImport.update({
    id: '/forecast_/budget-vs-actual',
    path: '/forecast/budget-vs-actual',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceForecast13WeekCashflowRoute =
  FinanceForecast13WeekCashflowRouteImport.update({
    id: '/forecast_/13-week-cashflow',
    path: '/forecast/13-week-cashflow',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceForecast12MonthPlRoute =
  FinanceForecast12MonthPlRouteImport.update({
    id: '/forecast_/12-month-pl',
    path: '/forecast/12-month-pl',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const FinanceDashboardsDashboardIdRoute =
  FinanceDashboardsDashboardIdRouteImport.update({
    id: '/dashboards_/$dashboardId',
    path: '/dashboards/$dashboardId',
    getParentRoute: () => FinanceRouteRoute,
  } as any)
const CommunityPostPostIdRoute = CommunityPostPostIdRouteImport.update({
  id: '/community/post/$postId',
  path: '/community/post/$postId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/users_/$userId',
  path: '/users/$userId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSignupCodesCodeRoute = AdminSignupCodesCodeRouteImport.update({
  id: '/signup-codes_/$code',
  path: '/signup-codes/$code',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiagnosticSettingsRoute = AdminDiagnosticSettingsRouteImport.update({
  id: '/diagnostic/settings',
  path: '/diagnostic/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiagnosticQuestionsRoute =
  AdminDiagnosticQuestionsRouteImport.update({
    id: '/diagnostic/questions',
    path: '/diagnostic/questions',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminDiagnosticInspectRoute = AdminDiagnosticInspectRouteImport.update({
  id: '/diagnostic/inspect',
  path: '/diagnostic/inspect',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiagnosticImportExportRoute =
  AdminDiagnosticImportExportRouteImport.update({
    id: '/diagnostic/import-export',
    path: '/diagnostic/import-export',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminDiagnosticGuardrailsRoute =
  AdminDiagnosticGuardrailsRouteImport.update({
    id: '/diagnostic/guardrails',
    path: '/diagnostic/guardrails',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCommunitiesNewRoute = AdminCommunitiesNewRouteImport.update({
  id: '/communities_/new',
  path: '/communities/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCommunitiesCommunityIdRoute =
  AdminCommunitiesCommunityIdRouteImport.update({
    id: '/communities_/$communityId',
    path: '/communities/$communityId',
    getParentRoute: () => AdminRoute,
  } as any)
const LearnCoursesCourseIdIndexRoute =
  LearnCoursesCourseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LearnCoursesCourseIdRoute,
  } as any)
const AuthorCoursesCourseIdEditRoute =
  AuthorCoursesCourseIdEditRouteImport.update({
    id: '/author/courses/$courseId/edit',
    path: '/author/courses/$courseId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthorAssessmentsAssessmentIdEditRoute =
  AuthorAssessmentsAssessmentIdEditRouteImport.update({
    id: '/author/assessments/$assessmentId/edit',
    path: '/author/assessments/$assessmentId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDiagnosticQuestionsIdRoute =
  AdminDiagnosticQuestionsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminDiagnosticQuestionsRoute,
  } as any)
const LearnCoursesCourseIdLessonsLessonIdRoute =
  LearnCoursesCourseIdLessonsLessonIdRouteImport.update({
    id: '/lessons/$lessonId',
    path: '/lessons/$lessonId',
    getParentRoute: () => LearnCoursesCourseIdRoute,
  } as any)
const AdminDiagnosticQuestionsIdTestRoute =
  AdminDiagnosticQuestionsIdTestRouteImport.update({
    id: '/test',
    path: '/test',
    getParentRoute: () => AdminDiagnosticQuestionsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/finance': typeof FinanceRouteRouteWithChildren
  '/hermes': typeof HermesRouteRouteWithChildren
  '/access_matrix': typeof Access_matrixRoute
  '/admin': typeof AdminRouteWithChildren
  '/checkout': typeof CheckoutRoute
  '/data-deletion': typeof DataDeletionRoute
  '/diagnostic': typeof DiagnosticRouteWithChildren
  '/diagnostic-admin': typeof DiagnosticAdminRoute
  '/events': typeof EventsRouteWithChildren
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/my-work': typeof MyWorkRoute
  '/onboarding': typeof OnboardingRoute
  '/plan': typeof PlanRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/rsvp': typeof RsvpRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/streams': typeof StreamsRoute
  '/terms': typeof TermsRoute
  '/timeline': typeof TimelineRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/admin/access': typeof AdminAccessRoute
  '/admin/access-requests': typeof AdminAccessRequestsRoute
  '/admin/ai-usage': typeof AdminAiUsageRoute
  '/admin/allowed-signups': typeof AdminAllowedSignupsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/avatar-check': typeof AdminAvatarCheckRoute
  '/admin/communities': typeof AdminCommunitiesRoute
  '/admin/developer': typeof AdminDeveloperRoute
  '/admin/event-purchases': typeof AdminEventPurchasesRoute
  '/admin/flags': typeof AdminFlagsRoute
  '/admin/free-courses': typeof AdminFreeCoursesRoute
  '/admin/import-sync': typeof AdminImportSyncRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/mentorship': typeof AdminMentorshipRoute
  '/admin/onboarding-questions': typeof AdminOnboardingQuestionsRoute
  '/admin/push-diagnostics': typeof AdminPushDiagnosticsRoute
  '/admin/revenue': typeof AdminRevenueRoute
  '/admin/sales': typeof AdminSalesRoute
  '/admin/security': typeof AdminSecurityRoute
  '/admin/signup-codes': typeof AdminSignupCodesRoute
  '/admin/speedies': typeof AdminSpeediesRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/surveys': typeof AdminSurveysRoute
  '/admin/tier-settings': typeof AdminTierSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/alfie/agent': typeof AlfieAgentRoute
  '/alfie/insights': typeof AlfieInsightsRoute
  '/alfie/settings': typeof AlfieSettingsRoute
  '/api/docs': typeof ApiDocsRoute
  '/assets/apps': typeof AssetsAppsRoute
  '/assets/templates': typeof AssetsTemplatesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/coaching/book': typeof CoachingBookRoute
  '/coaching/directory': typeof CoachingDirectoryRoute
  '/community/leaderboard': typeof CommunityLeaderboardRoute
  '/crm/contacts': typeof CrmContactsRoute
  '/crm/deals': typeof CrmDealsRoute
  '/crm/projects': typeof CrmProjectsRoute
  '/diagnostic/history': typeof DiagnosticHistoryRoute
  '/diagnostic/results': typeof DiagnosticResultsRoute
  '/diagnostic/roadmap': typeof DiagnosticRoadmapRoute
  '/diagnostics/gap-analysis': typeof DiagnosticsGapAnalysisRoute
  '/diagnostics/leadership': typeof DiagnosticsLeadershipRoute
  '/diagnostics/prime-path': typeof DiagnosticsPrimePathRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/finance/budget': typeof FinanceBudgetRoute
  '/finance/cashflow': typeof FinanceCashflowRoute
  '/finance/dashboards': typeof FinanceDashboardsRoute
  '/finance/data': typeof FinanceDataRoute
  '/finance/forecast': typeof FinanceForecastRoute
  '/finance/profit': typeof FinanceProfitRoute
  '/finance/reports': typeof FinanceReportsRoute
  '/finance/scenarios': typeof FinanceScenariosRoute
  '/finance/scorecard': typeof FinanceScorecardRoute
  '/hermes/builder': typeof HermesBuilderRoute
  '/hermes/definitions': typeof HermesDefinitionsRoute
  '/hermes/dlq': typeof HermesDlqRoute
  '/hermes/executions': typeof HermesExecutionsRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/learn/gamified': typeof LearnGamifiedRoute
  '/marketing/content': typeof MarketingContentRoute
  '/marketing/sales': typeof MarketingSalesRoute
  '/marketing/social': typeof MarketingSocialRoute
  '/mastermind/$mastermindId': typeof MastermindMastermindIdRoute
  '/operations/compliance': typeof OperationsComplianceRoute
  '/operations/policies': typeof OperationsPoliciesRoute
  '/operations/systems': typeof OperationsSystemsRoute
  '/org/$slug': typeof OrgSlugRoute
  '/recording/$recordingId': typeof RecordingRecordingIdRoute
  '/strategy/architecture': typeof StrategyArchitectureRoute
  '/strategy/business-plan': typeof StrategyBusinessPlanRoute
  '/team/culture': typeof TeamCultureRoute
  '/team/directory': typeof TeamDirectoryRoute
  '/team/hr': typeof TeamHrRoute
  '/team/roles': typeof TeamRolesRoute
  '/team/skills': typeof TeamSkillsRoute
  '/tracking/lead-lag': typeof TrackingLeadLagRoute
  '/tracking/reports': typeof TrackingReportsRoute
  '/admin/': typeof AdminIndexRoute
  '/alfie/': typeof AlfieIndexRoute
  '/assets/': typeof AssetsIndexRoute
  '/author/': typeof AuthorIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/coaching/': typeof CoachingIndexRoute
  '/community/': typeof CommunityIndexRoute
  '/crm/': typeof CrmIndexRoute
  '/diagnostic/': typeof DiagnosticIndexRoute
  '/diagnostics/': typeof DiagnosticsIndexRoute
  '/events/': typeof EventsIndexRoute
  '/finance/': typeof FinanceIndexRoute
  '/hermes/': typeof HermesIndexRoute
  '/learn/': typeof LearnIndexRoute
  '/marketing/': typeof MarketingIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/recordings/': typeof RecordingsIndexRoute
  '/strategy/': typeof StrategyIndexRoute
  '/team/': typeof TeamIndexRoute
  '/tracking/': typeof TrackingIndexRoute
  '/admin/communities/$communityId': typeof AdminCommunitiesCommunityIdRoute
  '/admin/communities/new': typeof AdminCommunitiesNewRoute
  '/admin/diagnostic/guardrails': typeof AdminDiagnosticGuardrailsRoute
  '/admin/diagnostic/import-export': typeof AdminDiagnosticImportExportRoute
  '/admin/diagnostic/inspect': typeof AdminDiagnosticInspectRoute
  '/admin/diagnostic/questions': typeof AdminDiagnosticQuestionsRouteWithChildren
  '/admin/diagnostic/settings': typeof AdminDiagnosticSettingsRoute
  '/admin/signup-codes/$code': typeof AdminSignupCodesCodeRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/community/post/$postId': typeof CommunityPostPostIdRoute
  '/finance/dashboards/$dashboardId': typeof FinanceDashboardsDashboardIdRoute
  '/finance/forecast/12-month-pl': typeof FinanceForecast12MonthPlRoute
  '/finance/forecast/13-week-cashflow': typeof FinanceForecast13WeekCashflowRoute
  '/finance/forecast/budget-vs-actual': typeof FinanceForecastBudgetVsActualRoute
  '/finance/forecast/financial-freedom': typeof FinanceForecastFinancialFreedomRoute
  '/finance/forecast/gp-per-hour': typeof FinanceForecastGpPerHourRoute
  '/finance/forecast/overhead-recovery': typeof FinanceForecastOverheadRecoveryRoute
  '/finance/forecast/profit-first': typeof FinanceForecastProfitFirstRoute
  '/finance/forecast/project-pricing': typeof FinanceForecastProjectPricingRoute
  '/finance/forecast/staff-mix': typeof FinanceForecastStaffMixRoute
  '/finance/forecast/what-if-scenarios': typeof FinanceForecastWhatIfScenariosRoute
  '/finance/xero/connect': typeof FinanceXeroConnectRoute
  '/finance/xero/mapping': typeof FinanceXeroMappingRoute
  '/hermes/executions/$executionId': typeof HermesExecutionsExecutionIdRoute
  '/learn/assessments/$assessmentId': typeof LearnAssessmentsAssessmentIdRoute
  '/learn/courses/$courseId': typeof LearnCoursesCourseIdRouteWithChildren
  '/learn/paths/$pathId': typeof LearnPathsPathIdRoute
  '/recordings/$source/$id': typeof RecordingsSourceIdRoute
  '/assets/$assetId/': typeof AssetsAssetIdIndexRoute
  '/learn/certificates/': typeof LearnCertificatesIndexRoute
  '/learn/courses/': typeof LearnCoursesIndexRoute
  '/admin/diagnostic/questions/$id': typeof AdminDiagnosticQuestionsIdRouteWithChildren
  '/author/assessments/$assessmentId/edit': typeof AuthorAssessmentsAssessmentIdEditRoute
  '/author/courses/$courseId/edit': typeof AuthorCoursesCourseIdEditRoute
  '/learn/courses/$courseId/': typeof LearnCoursesCourseIdIndexRoute
  '/admin/diagnostic/questions/$id/test': typeof AdminDiagnosticQuestionsIdTestRoute
  '/learn/courses/$courseId/lessons/$lessonId': typeof LearnCoursesCourseIdLessonsLessonIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access_matrix': typeof Access_matrixRoute
  '/checkout': typeof CheckoutRoute
  '/data-deletion': typeof DataDeletionRoute
  '/diagnostic-admin': typeof DiagnosticAdminRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/my-work': typeof MyWorkRoute
  '/onboarding': typeof OnboardingRoute
  '/plan': typeof PlanRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/rsvp': typeof RsvpRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/streams': typeof StreamsRoute
  '/terms': typeof TermsRoute
  '/timeline': typeof TimelineRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/admin/access': typeof AdminAccessRoute
  '/admin/access-requests': typeof AdminAccessRequestsRoute
  '/admin/ai-usage': typeof AdminAiUsageRoute
  '/admin/allowed-signups': typeof AdminAllowedSignupsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/avatar-check': typeof AdminAvatarCheckRoute
  '/admin/communities': typeof AdminCommunitiesRoute
  '/admin/developer': typeof AdminDeveloperRoute
  '/admin/event-purchases': typeof AdminEventPurchasesRoute
  '/admin/flags': typeof AdminFlagsRoute
  '/admin/free-courses': typeof AdminFreeCoursesRoute
  '/admin/import-sync': typeof AdminImportSyncRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/mentorship': typeof AdminMentorshipRoute
  '/admin/onboarding-questions': typeof AdminOnboardingQuestionsRoute
  '/admin/push-diagnostics': typeof AdminPushDiagnosticsRoute
  '/admin/revenue': typeof AdminRevenueRoute
  '/admin/sales': typeof AdminSalesRoute
  '/admin/security': typeof AdminSecurityRoute
  '/admin/signup-codes': typeof AdminSignupCodesRoute
  '/admin/speedies': typeof AdminSpeediesRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/surveys': typeof AdminSurveysRoute
  '/admin/tier-settings': typeof AdminTierSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/alfie/agent': typeof AlfieAgentRoute
  '/alfie/insights': typeof AlfieInsightsRoute
  '/alfie/settings': typeof AlfieSettingsRoute
  '/api/docs': typeof ApiDocsRoute
  '/assets/apps': typeof AssetsAppsRoute
  '/assets/templates': typeof AssetsTemplatesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/coaching/book': typeof CoachingBookRoute
  '/coaching/directory': typeof CoachingDirectoryRoute
  '/community/leaderboard': typeof CommunityLeaderboardRoute
  '/crm/contacts': typeof CrmContactsRoute
  '/crm/deals': typeof CrmDealsRoute
  '/crm/projects': typeof CrmProjectsRoute
  '/diagnostic/history': typeof DiagnosticHistoryRoute
  '/diagnostic/results': typeof DiagnosticResultsRoute
  '/diagnostic/roadmap': typeof DiagnosticRoadmapRoute
  '/diagnostics/gap-analysis': typeof DiagnosticsGapAnalysisRoute
  '/diagnostics/leadership': typeof DiagnosticsLeadershipRoute
  '/diagnostics/prime-path': typeof DiagnosticsPrimePathRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/finance/budget': typeof FinanceBudgetRoute
  '/finance/cashflow': typeof FinanceCashflowRoute
  '/finance/dashboards': typeof FinanceDashboardsRoute
  '/finance/data': typeof FinanceDataRoute
  '/finance/forecast': typeof FinanceForecastRoute
  '/finance/profit': typeof FinanceProfitRoute
  '/finance/reports': typeof FinanceReportsRoute
  '/finance/scenarios': typeof FinanceScenariosRoute
  '/finance/scorecard': typeof FinanceScorecardRoute
  '/hermes/builder': typeof HermesBuilderRoute
  '/hermes/definitions': typeof HermesDefinitionsRoute
  '/hermes/dlq': typeof HermesDlqRoute
  '/hermes/executions': typeof HermesExecutionsRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/learn/gamified': typeof LearnGamifiedRoute
  '/marketing/content': typeof MarketingContentRoute
  '/marketing/sales': typeof MarketingSalesRoute
  '/marketing/social': typeof MarketingSocialRoute
  '/mastermind/$mastermindId': typeof MastermindMastermindIdRoute
  '/operations/compliance': typeof OperationsComplianceRoute
  '/operations/policies': typeof OperationsPoliciesRoute
  '/operations/systems': typeof OperationsSystemsRoute
  '/org/$slug': typeof OrgSlugRoute
  '/recording/$recordingId': typeof RecordingRecordingIdRoute
  '/strategy/architecture': typeof StrategyArchitectureRoute
  '/strategy/business-plan': typeof StrategyBusinessPlanRoute
  '/team/culture': typeof TeamCultureRoute
  '/team/directory': typeof TeamDirectoryRoute
  '/team/hr': typeof TeamHrRoute
  '/team/roles': typeof TeamRolesRoute
  '/team/skills': typeof TeamSkillsRoute
  '/tracking/lead-lag': typeof TrackingLeadLagRoute
  '/tracking/reports': typeof TrackingReportsRoute
  '/admin': typeof AdminIndexRoute
  '/alfie': typeof AlfieIndexRoute
  '/assets': typeof AssetsIndexRoute
  '/author': typeof AuthorIndexRoute
  '/chat': typeof ChatIndexRoute
  '/coaching': typeof CoachingIndexRoute
  '/community': typeof CommunityIndexRoute
  '/crm': typeof CrmIndexRoute
  '/diagnostic': typeof DiagnosticIndexRoute
  '/diagnostics': typeof DiagnosticsIndexRoute
  '/events': typeof EventsIndexRoute
  '/finance': typeof FinanceIndexRoute
  '/hermes': typeof HermesIndexRoute
  '/learn': typeof LearnIndexRoute
  '/marketing': typeof MarketingIndexRoute
  '/operations': typeof OperationsIndexRoute
  '/recordings': typeof RecordingsIndexRoute
  '/strategy': typeof StrategyIndexRoute
  '/team': typeof TeamIndexRoute
  '/tracking': typeof TrackingIndexRoute
  '/admin/communities/$communityId': typeof AdminCommunitiesCommunityIdRoute
  '/admin/communities/new': typeof AdminCommunitiesNewRoute
  '/admin/diagnostic/guardrails': typeof AdminDiagnosticGuardrailsRoute
  '/admin/diagnostic/import-export': typeof AdminDiagnosticImportExportRoute
  '/admin/diagnostic/inspect': typeof AdminDiagnosticInspectRoute
  '/admin/diagnostic/questions': typeof AdminDiagnosticQuestionsRouteWithChildren
  '/admin/diagnostic/settings': typeof AdminDiagnosticSettingsRoute
  '/admin/signup-codes/$code': typeof AdminSignupCodesCodeRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/community/post/$postId': typeof CommunityPostPostIdRoute
  '/finance/dashboards/$dashboardId': typeof FinanceDashboardsDashboardIdRoute
  '/finance/forecast/12-month-pl': typeof FinanceForecast12MonthPlRoute
  '/finance/forecast/13-week-cashflow': typeof FinanceForecast13WeekCashflowRoute
  '/finance/forecast/budget-vs-actual': typeof FinanceForecastBudgetVsActualRoute
  '/finance/forecast/financial-freedom': typeof FinanceForecastFinancialFreedomRoute
  '/finance/forecast/gp-per-hour': typeof FinanceForecastGpPerHourRoute
  '/finance/forecast/overhead-recovery': typeof FinanceForecastOverheadRecoveryRoute
  '/finance/forecast/profit-first': typeof FinanceForecastProfitFirstRoute
  '/finance/forecast/project-pricing': typeof FinanceForecastProjectPricingRoute
  '/finance/forecast/staff-mix': typeof FinanceForecastStaffMixRoute
  '/finance/forecast/what-if-scenarios': typeof FinanceForecastWhatIfScenariosRoute
  '/finance/xero/connect': typeof FinanceXeroConnectRoute
  '/finance/xero/mapping': typeof FinanceXeroMappingRoute
  '/hermes/executions/$executionId': typeof HermesExecutionsExecutionIdRoute
  '/learn/assessments/$assessmentId': typeof LearnAssessmentsAssessmentIdRoute
  '/learn/paths/$pathId': typeof LearnPathsPathIdRoute
  '/recordings/$source/$id': typeof RecordingsSourceIdRoute
  '/assets/$assetId': typeof AssetsAssetIdIndexRoute
  '/learn/certificates': typeof LearnCertificatesIndexRoute
  '/learn/courses': typeof LearnCoursesIndexRoute
  '/admin/diagnostic/questions/$id': typeof AdminDiagnosticQuestionsIdRouteWithChildren
  '/author/assessments/$assessmentId/edit': typeof AuthorAssessmentsAssessmentIdEditRoute
  '/author/courses/$courseId/edit': typeof AuthorCoursesCourseIdEditRoute
  '/learn/courses/$courseId': typeof LearnCoursesCourseIdIndexRoute
  '/admin/diagnostic/questions/$id/test': typeof AdminDiagnosticQuestionsIdTestRoute
  '/learn/courses/$courseId/lessons/$lessonId': typeof LearnCoursesCourseIdLessonsLessonIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/finance': typeof FinanceRouteRouteWithChildren
  '/hermes': typeof HermesRouteRouteWithChildren
  '/access_matrix': typeof Access_matrixRoute
  '/admin': typeof AdminRouteWithChildren
  '/checkout': typeof CheckoutRoute
  '/data-deletion': typeof DataDeletionRoute
  '/diagnostic': typeof DiagnosticRouteWithChildren
  '/diagnostic-admin': typeof DiagnosticAdminRoute
  '/events': typeof EventsRouteWithChildren
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/my-work': typeof MyWorkRoute
  '/onboarding': typeof OnboardingRoute
  '/plan': typeof PlanRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/rsvp': typeof RsvpRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/streams': typeof StreamsRoute
  '/terms': typeof TermsRoute
  '/timeline': typeof TimelineRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/admin/access': typeof AdminAccessRoute
  '/admin/access-requests': typeof AdminAccessRequestsRoute
  '/admin/ai-usage': typeof AdminAiUsageRoute
  '/admin/allowed-signups': typeof AdminAllowedSignupsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/avatar-check': typeof AdminAvatarCheckRoute
  '/admin/communities': typeof AdminCommunitiesRoute
  '/admin/developer': typeof AdminDeveloperRoute
  '/admin/event-purchases': typeof AdminEventPurchasesRoute
  '/admin/flags': typeof AdminFlagsRoute
  '/admin/free-courses': typeof AdminFreeCoursesRoute
  '/admin/import-sync': typeof AdminImportSyncRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/mentorship': typeof AdminMentorshipRoute
  '/admin/onboarding-questions': typeof AdminOnboardingQuestionsRoute
  '/admin/push-diagnostics': typeof AdminPushDiagnosticsRoute
  '/admin/revenue': typeof AdminRevenueRoute
  '/admin/sales': typeof AdminSalesRoute
  '/admin/security': typeof AdminSecurityRoute
  '/admin/signup-codes': typeof AdminSignupCodesRoute
  '/admin/speedies': typeof AdminSpeediesRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/surveys': typeof AdminSurveysRoute
  '/admin/tier-settings': typeof AdminTierSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/alfie/agent': typeof AlfieAgentRoute
  '/alfie/insights': typeof AlfieInsightsRoute
  '/alfie/settings': typeof AlfieSettingsRoute
  '/api/docs': typeof ApiDocsRoute
  '/assets/apps': typeof AssetsAppsRoute
  '/assets/templates': typeof AssetsTemplatesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/coaching/book': typeof CoachingBookRoute
  '/coaching/directory': typeof CoachingDirectoryRoute
  '/community/leaderboard': typeof CommunityLeaderboardRoute
  '/crm/contacts': typeof CrmContactsRoute
  '/crm/deals': typeof CrmDealsRoute
  '/crm/projects': typeof CrmProjectsRoute
  '/diagnostic/history': typeof DiagnosticHistoryRoute
  '/diagnostic/results': typeof DiagnosticResultsRoute
  '/diagnostic/roadmap': typeof DiagnosticRoadmapRoute
  '/diagnostics/gap-analysis': typeof DiagnosticsGapAnalysisRoute
  '/diagnostics/leadership': typeof DiagnosticsLeadershipRoute
  '/diagnostics/prime-path': typeof DiagnosticsPrimePathRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/finance/budget': typeof FinanceBudgetRoute
  '/finance/cashflow': typeof FinanceCashflowRoute
  '/finance/dashboards': typeof FinanceDashboardsRoute
  '/finance/data': typeof FinanceDataRoute
  '/finance/forecast': typeof FinanceForecastRoute
  '/finance/profit': typeof FinanceProfitRoute
  '/finance/reports': typeof FinanceReportsRoute
  '/finance/scenarios': typeof FinanceScenariosRoute
  '/finance/scorecard': typeof FinanceScorecardRoute
  '/hermes/builder': typeof HermesBuilderRoute
  '/hermes/definitions': typeof HermesDefinitionsRoute
  '/hermes/dlq': typeof HermesDlqRoute
  '/hermes/executions': typeof HermesExecutionsRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/learn/gamified': typeof LearnGamifiedRoute
  '/marketing/content': typeof MarketingContentRoute
  '/marketing/sales': typeof MarketingSalesRoute
  '/marketing/social': typeof MarketingSocialRoute
  '/mastermind/$mastermindId': typeof MastermindMastermindIdRoute
  '/operations/compliance': typeof OperationsComplianceRoute
  '/operations/policies': typeof OperationsPoliciesRoute
  '/operations/systems': typeof OperationsSystemsRoute
  '/org/$slug': typeof OrgSlugRoute
  '/recording/$recordingId': typeof RecordingRecordingIdRoute
  '/strategy/architecture': typeof StrategyArchitectureRoute
  '/strategy/business-plan': typeof StrategyBusinessPlanRoute
  '/team/culture': typeof TeamCultureRoute
  '/team/directory': typeof TeamDirectoryRoute
  '/team/hr': typeof TeamHrRoute
  '/team/roles': typeof TeamRolesRoute
  '/team/skills': typeof TeamSkillsRoute
  '/tracking/lead-lag': typeof TrackingLeadLagRoute
  '/tracking/reports': typeof TrackingReportsRoute
  '/admin/': typeof AdminIndexRoute
  '/alfie/': typeof AlfieIndexRoute
  '/assets/': typeof AssetsIndexRoute
  '/author/': typeof AuthorIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/coaching/': typeof CoachingIndexRoute
  '/community/': typeof CommunityIndexRoute
  '/crm/': typeof CrmIndexRoute
  '/diagnostic/': typeof DiagnosticIndexRoute
  '/diagnostics/': typeof DiagnosticsIndexRoute
  '/events/': typeof EventsIndexRoute
  '/finance/': typeof FinanceIndexRoute
  '/hermes/': typeof HermesIndexRoute
  '/learn/': typeof LearnIndexRoute
  '/marketing/': typeof MarketingIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/recordings/': typeof RecordingsIndexRoute
  '/strategy/': typeof StrategyIndexRoute
  '/team/': typeof TeamIndexRoute
  '/tracking/': typeof TrackingIndexRoute
  '/admin/communities_/$communityId': typeof AdminCommunitiesCommunityIdRoute
  '/admin/communities_/new': typeof AdminCommunitiesNewRoute
  '/admin/diagnostic/guardrails': typeof AdminDiagnosticGuardrailsRoute
  '/admin/diagnostic/import-export': typeof AdminDiagnosticImportExportRoute
  '/admin/diagnostic/inspect': typeof AdminDiagnosticInspectRoute
  '/admin/diagnostic/questions': typeof AdminDiagnosticQuestionsRouteWithChildren
  '/admin/diagnostic/settings': typeof AdminDiagnosticSettingsRoute
  '/admin/signup-codes_/$code': typeof AdminSignupCodesCodeRoute
  '/admin/users_/$userId': typeof AdminUsersUserIdRoute
  '/community/post/$postId': typeof CommunityPostPostIdRoute
  '/finance/dashboards_/$dashboardId': typeof FinanceDashboardsDashboardIdRoute
  '/finance/forecast_/12-month-pl': typeof FinanceForecast12MonthPlRoute
  '/finance/forecast_/13-week-cashflow': typeof FinanceForecast13WeekCashflowRoute
  '/finance/forecast_/budget-vs-actual': typeof FinanceForecastBudgetVsActualRoute
  '/finance/forecast_/financial-freedom': typeof FinanceForecastFinancialFreedomRoute
  '/finance/forecast_/gp-per-hour': typeof FinanceForecastGpPerHourRoute
  '/finance/forecast_/overhead-recovery': typeof FinanceForecastOverheadRecoveryRoute
  '/finance/forecast_/profit-first': typeof FinanceForecastProfitFirstRoute
  '/finance/forecast_/project-pricing': typeof FinanceForecastProjectPricingRoute
  '/finance/forecast_/staff-mix': typeof FinanceForecastStaffMixRoute
  '/finance/forecast_/what-if-scenarios': typeof FinanceForecastWhatIfScenariosRoute
  '/finance/xero/connect': typeof FinanceXeroConnectRoute
  '/finance/xero/mapping': typeof FinanceXeroMappingRoute
  '/hermes/executions_/$executionId': typeof HermesExecutionsExecutionIdRoute
  '/learn/assessments/$assessmentId': typeof LearnAssessmentsAssessmentIdRoute
  '/learn/courses/$courseId': typeof LearnCoursesCourseIdRouteWithChildren
  '/learn/paths/$pathId': typeof LearnPathsPathIdRoute
  '/recordings/$source/$id': typeof RecordingsSourceIdRoute
  '/assets/$assetId/': typeof AssetsAssetIdIndexRoute
  '/learn/certificates/': typeof LearnCertificatesIndexRoute
  '/learn/courses/': typeof LearnCoursesIndexRoute
  '/admin/diagnostic/questions/$id': typeof AdminDiagnosticQuestionsIdRouteWithChildren
  '/author/assessments/$assessmentId/edit': typeof AuthorAssessmentsAssessmentIdEditRoute
  '/author/courses/$courseId/edit': typeof AuthorCoursesCourseIdEditRoute
  '/learn/courses/$courseId/': typeof LearnCoursesCourseIdIndexRoute
  '/admin/diagnostic/questions/$id/test': typeof AdminDiagnosticQuestionsIdTestRoute
  '/learn/courses/$courseId/lessons/$lessonId': typeof LearnCoursesCourseIdLessonsLessonIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/finance'
    | '/hermes'
    | '/access_matrix'
    | '/admin'
    | '/checkout'
    | '/data-deletion'
    | '/diagnostic'
    | '/diagnostic-admin'
    | '/events'
    | '/inbox'
    | '/login'
    | '/my-work'
    | '/onboarding'
    | '/plan'
    | '/privacy'
    | '/reset-password'
    | '/rsvp'
    | '/settings'
    | '/signup'
    | '/streams'
    | '/terms'
    | '/timeline'
    | '/unsubscribe'
    | '/verify'
    | '/admin/access'
    | '/admin/access-requests'
    | '/admin/ai-usage'
    | '/admin/allowed-signups'
    | '/admin/analytics'
    | '/admin/avatar-check'
    | '/admin/communities'
    | '/admin/developer'
    | '/admin/event-purchases'
    | '/admin/flags'
    | '/admin/free-courses'
    | '/admin/import-sync'
    | '/admin/integrations'
    | '/admin/mentorship'
    | '/admin/onboarding-questions'
    | '/admin/push-diagnostics'
    | '/admin/revenue'
    | '/admin/sales'
    | '/admin/security'
    | '/admin/signup-codes'
    | '/admin/speedies'
    | '/admin/subscriptions'
    | '/admin/surveys'
    | '/admin/tier-settings'
    | '/admin/users'
    | '/alfie/agent'
    | '/alfie/insights'
    | '/alfie/settings'
    | '/api/docs'
    | '/assets/apps'
    | '/assets/templates'
    | '/auth/callback'
    | '/auth/confirm'
    | '/coaching/book'
    | '/coaching/directory'
    | '/community/leaderboard'
    | '/crm/contacts'
    | '/crm/deals'
    | '/crm/projects'
    | '/diagnostic/history'
    | '/diagnostic/results'
    | '/diagnostic/roadmap'
    | '/diagnostics/gap-analysis'
    | '/diagnostics/leadership'
    | '/diagnostics/prime-path'
    | '/events/$eventId'
    | '/finance/budget'
    | '/finance/cashflow'
    | '/finance/dashboards'
    | '/finance/data'
    | '/finance/forecast'
    | '/finance/profit'
    | '/finance/reports'
    | '/finance/scenarios'
    | '/finance/scorecard'
    | '/hermes/builder'
    | '/hermes/definitions'
    | '/hermes/dlq'
    | '/hermes/executions'
    | '/invitations/accept'
    | '/learn/gamified'
    | '/marketing/content'
    | '/marketing/sales'
    | '/marketing/social'
    | '/mastermind/$mastermindId'
    | '/operations/compliance'
    | '/operations/policies'
    | '/operations/systems'
    | '/org/$slug'
    | '/recording/$recordingId'
    | '/strategy/architecture'
    | '/strategy/business-plan'
    | '/team/culture'
    | '/team/directory'
    | '/team/hr'
    | '/team/roles'
    | '/team/skills'
    | '/tracking/lead-lag'
    | '/tracking/reports'
    | '/admin/'
    | '/alfie/'
    | '/assets/'
    | '/author/'
    | '/chat/'
    | '/coaching/'
    | '/community/'
    | '/crm/'
    | '/diagnostic/'
    | '/diagnostics/'
    | '/events/'
    | '/finance/'
    | '/hermes/'
    | '/learn/'
    | '/marketing/'
    | '/operations/'
    | '/recordings/'
    | '/strategy/'
    | '/team/'
    | '/tracking/'
    | '/admin/communities/$communityId'
    | '/admin/communities/new'
    | '/admin/diagnostic/guardrails'
    | '/admin/diagnostic/import-export'
    | '/admin/diagnostic/inspect'
    | '/admin/diagnostic/questions'
    | '/admin/diagnostic/settings'
    | '/admin/signup-codes/$code'
    | '/admin/users/$userId'
    | '/community/post/$postId'
    | '/finance/dashboards/$dashboardId'
    | '/finance/forecast/12-month-pl'
    | '/finance/forecast/13-week-cashflow'
    | '/finance/forecast/budget-vs-actual'
    | '/finance/forecast/financial-freedom'
    | '/finance/forecast/gp-per-hour'
    | '/finance/forecast/overhead-recovery'
    | '/finance/forecast/profit-first'
    | '/finance/forecast/project-pricing'
    | '/finance/forecast/staff-mix'
    | '/finance/forecast/what-if-scenarios'
    | '/finance/xero/connect'
    | '/finance/xero/mapping'
    | '/hermes/executions/$executionId'
    | '/learn/assessments/$assessmentId'
    | '/learn/courses/$courseId'
    | '/learn/paths/$pathId'
    | '/recordings/$source/$id'
    | '/assets/$assetId/'
    | '/learn/certificates/'
    | '/learn/courses/'
    | '/admin/diagnostic/questions/$id'
    | '/author/assessments/$assessmentId/edit'
    | '/author/courses/$courseId/edit'
    | '/learn/courses/$courseId/'
    | '/admin/diagnostic/questions/$id/test'
    | '/learn/courses/$courseId/lessons/$lessonId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access_matrix'
    | '/checkout'
    | '/data-deletion'
    | '/diagnostic-admin'
    | '/inbox'
    | '/login'
    | '/my-work'
    | '/onboarding'
    | '/plan'
    | '/privacy'
    | '/reset-password'
    | '/rsvp'
    | '/settings'
    | '/signup'
    | '/streams'
    | '/terms'
    | '/timeline'
    | '/unsubscribe'
    | '/verify'
    | '/admin/access'
    | '/admin/access-requests'
    | '/admin/ai-usage'
    | '/admin/allowed-signups'
    | '/admin/analytics'
    | '/admin/avatar-check'
    | '/admin/communities'
    | '/admin/developer'
    | '/admin/event-purchases'
    | '/admin/flags'
    | '/admin/free-courses'
    | '/admin/import-sync'
    | '/admin/integrations'
    | '/admin/mentorship'
    | '/admin/onboarding-questions'
    | '/admin/push-diagnostics'
    | '/admin/revenue'
    | '/admin/sales'
    | '/admin/security'
    | '/admin/signup-codes'
    | '/admin/speedies'
    | '/admin/subscriptions'
    | '/admin/surveys'
    | '/admin/tier-settings'
    | '/admin/users'
    | '/alfie/agent'
    | '/alfie/insights'
    | '/alfie/settings'
    | '/api/docs'
    | '/assets/apps'
    | '/assets/templates'
    | '/auth/callback'
    | '/auth/confirm'
    | '/coaching/book'
    | '/coaching/directory'
    | '/community/leaderboard'
    | '/crm/contacts'
    | '/crm/deals'
    | '/crm/projects'
    | '/diagnostic/history'
    | '/diagnostic/results'
    | '/diagnostic/roadmap'
    | '/diagnostics/gap-analysis'
    | '/diagnostics/leadership'
    | '/diagnostics/prime-path'
    | '/events/$eventId'
    | '/finance/budget'
    | '/finance/cashflow'
    | '/finance/dashboards'
    | '/finance/data'
    | '/finance/forecast'
    | '/finance/profit'
    | '/finance/reports'
    | '/finance/scenarios'
    | '/finance/scorecard'
    | '/hermes/builder'
    | '/hermes/definitions'
    | '/hermes/dlq'
    | '/hermes/executions'
    | '/invitations/accept'
    | '/learn/gamified'
    | '/marketing/content'
    | '/marketing/sales'
    | '/marketing/social'
    | '/mastermind/$mastermindId'
    | '/operations/compliance'
    | '/operations/policies'
    | '/operations/systems'
    | '/org/$slug'
    | '/recording/$recordingId'
    | '/strategy/architecture'
    | '/strategy/business-plan'
    | '/team/culture'
    | '/team/directory'
    | '/team/hr'
    | '/team/roles'
    | '/team/skills'
    | '/tracking/lead-lag'
    | '/tracking/reports'
    | '/admin'
    | '/alfie'
    | '/assets'
    | '/author'
    | '/chat'
    | '/coaching'
    | '/community'
    | '/crm'
    | '/diagnostic'
    | '/diagnostics'
    | '/events'
    | '/finance'
    | '/hermes'
    | '/learn'
    | '/marketing'
    | '/operations'
    | '/recordings'
    | '/strategy'
    | '/team'
    | '/tracking'
    | '/admin/communities/$communityId'
    | '/admin/communities/new'
    | '/admin/diagnostic/guardrails'
    | '/admin/diagnostic/import-export'
    | '/admin/diagnostic/inspect'
    | '/admin/diagnostic/questions'
    | '/admin/diagnostic/settings'
    | '/admin/signup-codes/$code'
    | '/admin/users/$userId'
    | '/community/post/$postId'
    | '/finance/dashboards/$dashboardId'
    | '/finance/forecast/12-month-pl'
    | '/finance/forecast/13-week-cashflow'
    | '/finance/forecast/budget-vs-actual'
    | '/finance/forecast/financial-freedom'
    | '/finance/forecast/gp-per-hour'
    | '/finance/forecast/overhead-recovery'
    | '/finance/forecast/profit-first'
    | '/finance/forecast/project-pricing'
    | '/finance/forecast/staff-mix'
    | '/finance/forecast/what-if-scenarios'
    | '/finance/xero/connect'
    | '/finance/xero/mapping'
    | '/hermes/executions/$executionId'
    | '/learn/assessments/$assessmentId'
    | '/learn/paths/$pathId'
    | '/recordings/$source/$id'
    | '/assets/$assetId'
    | '/learn/certificates'
    | '/learn/courses'
    | '/admin/diagnostic/questions/$id'
    | '/author/assessments/$assessmentId/edit'
    | '/author/courses/$courseId/edit'
    | '/learn/courses/$courseId'
    | '/admin/diagnostic/questions/$id/test'
    | '/learn/courses/$courseId/lessons/$lessonId'
  id:
    | '__root__'
    | '/'
    | '/finance'
    | '/hermes'
    | '/access_matrix'
    | '/admin'
    | '/checkout'
    | '/data-deletion'
    | '/diagnostic'
    | '/diagnostic-admin'
    | '/events'
    | '/inbox'
    | '/login'
    | '/my-work'
    | '/onboarding'
    | '/plan'
    | '/privacy'
    | '/reset-password'
    | '/rsvp'
    | '/settings'
    | '/signup'
    | '/streams'
    | '/terms'
    | '/timeline'
    | '/unsubscribe'
    | '/verify'
    | '/admin/access'
    | '/admin/access-requests'
    | '/admin/ai-usage'
    | '/admin/allowed-signups'
    | '/admin/analytics'
    | '/admin/avatar-check'
    | '/admin/communities'
    | '/admin/developer'
    | '/admin/event-purchases'
    | '/admin/flags'
    | '/admin/free-courses'
    | '/admin/import-sync'
    | '/admin/integrations'
    | '/admin/mentorship'
    | '/admin/onboarding-questions'
    | '/admin/push-diagnostics'
    | '/admin/revenue'
    | '/admin/sales'
    | '/admin/security'
    | '/admin/signup-codes'
    | '/admin/speedies'
    | '/admin/subscriptions'
    | '/admin/surveys'
    | '/admin/tier-settings'
    | '/admin/users'
    | '/alfie/agent'
    | '/alfie/insights'
    | '/alfie/settings'
    | '/api/docs'
    | '/assets/apps'
    | '/assets/templates'
    | '/auth/callback'
    | '/auth/confirm'
    | '/coaching/book'
    | '/coaching/directory'
    | '/community/leaderboard'
    | '/crm/contacts'
    | '/crm/deals'
    | '/crm/projects'
    | '/diagnostic/history'
    | '/diagnostic/results'
    | '/diagnostic/roadmap'
    | '/diagnostics/gap-analysis'
    | '/diagnostics/leadership'
    | '/diagnostics/prime-path'
    | '/events/$eventId'
    | '/finance/budget'
    | '/finance/cashflow'
    | '/finance/dashboards'
    | '/finance/data'
    | '/finance/forecast'
    | '/finance/profit'
    | '/finance/reports'
    | '/finance/scenarios'
    | '/finance/scorecard'
    | '/hermes/builder'
    | '/hermes/definitions'
    | '/hermes/dlq'
    | '/hermes/executions'
    | '/invitations/accept'
    | '/learn/gamified'
    | '/marketing/content'
    | '/marketing/sales'
    | '/marketing/social'
    | '/mastermind/$mastermindId'
    | '/operations/compliance'
    | '/operations/policies'
    | '/operations/systems'
    | '/org/$slug'
    | '/recording/$recordingId'
    | '/strategy/architecture'
    | '/strategy/business-plan'
    | '/team/culture'
    | '/team/directory'
    | '/team/hr'
    | '/team/roles'
    | '/team/skills'
    | '/tracking/lead-lag'
    | '/tracking/reports'
    | '/admin/'
    | '/alfie/'
    | '/assets/'
    | '/author/'
    | '/chat/'
    | '/coaching/'
    | '/community/'
    | '/crm/'
    | '/diagnostic/'
    | '/diagnostics/'
    | '/events/'
    | '/finance/'
    | '/hermes/'
    | '/learn/'
    | '/marketing/'
    | '/operations/'
    | '/recordings/'
    | '/strategy/'
    | '/team/'
    | '/tracking/'
    | '/admin/communities_/$communityId'
    | '/admin/communities_/new'
    | '/admin/diagnostic/guardrails'
    | '/admin/diagnostic/import-export'
    | '/admin/diagnostic/inspect'
    | '/admin/diagnostic/questions'
    | '/admin/diagnostic/settings'
    | '/admin/signup-codes_/$code'
    | '/admin/users_/$userId'
    | '/community/post/$postId'
    | '/finance/dashboards_/$dashboardId'
    | '/finance/forecast_/12-month-pl'
    | '/finance/forecast_/13-week-cashflow'
    | '/finance/forecast_/budget-vs-actual'
    | '/finance/forecast_/financial-freedom'
    | '/finance/forecast_/gp-per-hour'
    | '/finance/forecast_/overhead-recovery'
    | '/finance/forecast_/profit-first'
    | '/finance/forecast_/project-pricing'
    | '/finance/forecast_/staff-mix'
    | '/finance/forecast_/what-if-scenarios'
    | '/finance/xero/connect'
    | '/finance/xero/mapping'
    | '/hermes/executions_/$executionId'
    | '/learn/assessments/$assessmentId'
    | '/learn/courses/$courseId'
    | '/learn/paths/$pathId'
    | '/recordings/$source/$id'
    | '/assets/$assetId/'
    | '/learn/certificates/'
    | '/learn/courses/'
    | '/admin/diagnostic/questions/$id'
    | '/author/assessments/$assessmentId/edit'
    | '/author/courses/$courseId/edit'
    | '/learn/courses/$courseId/'
    | '/admin/diagnostic/questions/$id/test'
    | '/learn/courses/$courseId/lessons/$lessonId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FinanceRouteRoute: typeof FinanceRouteRouteWithChildren
  HermesRouteRoute: typeof HermesRouteRouteWithChildren
  Access_matrixRoute: typeof Access_matrixRoute
  AdminRoute: typeof AdminRouteWithChildren
  CheckoutRoute: typeof CheckoutRoute
  DataDeletionRoute: typeof DataDeletionRoute
  DiagnosticRoute: typeof DiagnosticRouteWithChildren
  DiagnosticAdminRoute: typeof DiagnosticAdminRoute
  EventsRoute: typeof EventsRouteWithChildren
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  MyWorkRoute: typeof MyWorkRoute
  OnboardingRoute: typeof OnboardingRoute
  PlanRoute: typeof PlanRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  RsvpRoute: typeof RsvpRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  StreamsRoute: typeof StreamsRoute
  TermsRoute: typeof TermsRoute
  TimelineRoute: typeof TimelineRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  VerifyRoute: typeof VerifyRoute
  AlfieAgentRoute: typeof AlfieAgentRoute
  AlfieInsightsRoute: typeof AlfieInsightsRoute
  AlfieSettingsRoute: typeof AlfieSettingsRoute
  ApiDocsRoute: typeof ApiDocsRoute
  AssetsAppsRoute: typeof AssetsAppsRoute
  AssetsTemplatesRoute: typeof AssetsTemplatesRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthConfirmRoute: typeof AuthConfirmRoute
  CoachingBookRoute: typeof CoachingBookRoute
  CoachingDirectoryRoute: typeof CoachingDirectoryRoute
  CommunityLeaderboardRoute: typeof CommunityLeaderboardRoute
  CrmContactsRoute: typeof CrmContactsRoute
  CrmDealsRoute: typeof CrmDealsRoute
  CrmProjectsRoute: typeof CrmProjectsRoute
  DiagnosticsGapAnalysisRoute: typeof DiagnosticsGapAnalysisRoute
  DiagnosticsLeadershipRoute: typeof DiagnosticsLeadershipRoute
  DiagnosticsPrimePathRoute: typeof DiagnosticsPrimePathRoute
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute
  LearnGamifiedRoute: typeof LearnGamifiedRoute
  MarketingContentRoute: typeof MarketingContentRoute
  MarketingSalesRoute: typeof MarketingSalesRoute
  MarketingSocialRoute: typeof MarketingSocialRoute
  MastermindMastermindIdRoute: typeof MastermindMastermindIdRoute
  OperationsComplianceRoute: typeof OperationsComplianceRoute
  OperationsPoliciesRoute: typeof OperationsPoliciesRoute
  OperationsSystemsRoute: typeof OperationsSystemsRoute
  OrgSlugRoute: typeof OrgSlugRoute
  RecordingRecordingIdRoute: typeof RecordingRecordingIdRoute
  StrategyArchitectureRoute: typeof StrategyArchitectureRoute
  StrategyBusinessPlanRoute: typeof StrategyBusinessPlanRoute
  TeamCultureRoute: typeof TeamCultureRoute
  TeamDirectoryRoute: typeof TeamDirectoryRoute
  TeamHrRoute: typeof TeamHrRoute
  TeamRolesRoute: typeof TeamRolesRoute
  TeamSkillsRoute: typeof TeamSkillsRoute
  TrackingLeadLagRoute: typeof TrackingLeadLagRoute
  TrackingReportsRoute: typeof TrackingReportsRoute
  AlfieIndexRoute: typeof AlfieIndexRoute
  AssetsIndexRoute: typeof AssetsIndexRoute
  AuthorIndexRoute: typeof AuthorIndexRoute
  ChatIndexRoute: typeof ChatIndexRoute
  CoachingIndexRoute: typeof CoachingIndexRoute
  CommunityIndexRoute: typeof CommunityIndexRoute
  CrmIndexRoute: typeof CrmIndexRoute
  DiagnosticsIndexRoute: typeof DiagnosticsIndexRoute
  LearnIndexRoute: typeof LearnIndexRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  OperationsIndexRoute: typeof OperationsIndexRoute
  RecordingsIndexRoute: typeof RecordingsIndexRoute
  StrategyIndexRoute: typeof StrategyIndexRoute
  TeamIndexRoute: typeof TeamIndexRoute
  TrackingIndexRoute: typeof TrackingIndexRoute
  CommunityPostPostIdRoute: typeof CommunityPostPostIdRoute
  LearnAssessmentsAssessmentIdRoute: typeof LearnAssessmentsAssessmentIdRoute
  LearnCoursesCourseIdRoute: typeof LearnCoursesCourseIdRouteWithChildren
  LearnPathsPathIdRoute: typeof LearnPathsPathIdRoute
  RecordingsSourceIdRoute: typeof RecordingsSourceIdRoute
  AssetsAssetIdIndexRoute: typeof AssetsAssetIdIndexRoute
  LearnCertificatesIndexRoute: typeof LearnCertificatesIndexRoute
  LearnCoursesIndexRoute: typeof LearnCoursesIndexRoute
  AuthorAssessmentsAssessmentIdEditRoute: typeof AuthorAssessmentsAssessmentIdEditRoute
  AuthorCoursesCourseIdEditRoute: typeof AuthorCoursesCourseIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timeline': {
      id: '/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof TimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/streams': {
      id: '/streams'
      path: '/streams'
      fullPath: '/streams'
      preLoaderRoute: typeof StreamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rsvp': {
      id: '/rsvp'
      path: '/rsvp'
      fullPath: '/rsvp'
      preLoaderRoute: typeof RsvpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan': {
      id: '/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof PlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-work': {
      id: '/my-work'
      path: '/my-work'
      fullPath: '/my-work'
      preLoaderRoute: typeof MyWorkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnostic-admin': {
      id: '/diagnostic-admin'
      path: '/diagnostic-admin'
      fullPath: '/diagnostic-admin'
      preLoaderRoute: typeof DiagnosticAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnostic': {
      id: '/diagnostic'
      path: '/diagnostic'
      fullPath: '/diagnostic'
      preLoaderRoute: typeof DiagnosticRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-deletion': {
      id: '/data-deletion'
      path: '/data-deletion'
      fullPath: '/data-deletion'
      preLoaderRoute: typeof DataDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access_matrix': {
      id: '/access_matrix'
      path: '/access_matrix'
      fullPath: '/access_matrix'
      preLoaderRoute: typeof Access_matrixRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hermes': {
      id: '/hermes'
      path: '/hermes'
      fullPath: '/hermes'
      preLoaderRoute: typeof HermesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracking/': {
      id: '/tracking/'
      path: '/tracking'
      fullPath: '/tracking/'
      preLoaderRoute: typeof TrackingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/': {
      id: '/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof TeamIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategy/': {
      id: '/strategy/'
      path: '/strategy'
      fullPath: '/strategy/'
      preLoaderRoute: typeof StrategyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings/': {
      id: '/recordings/'
      path: '/recordings'
      fullPath: '/recordings/'
      preLoaderRoute: typeof RecordingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/': {
      id: '/operations/'
      path: '/operations'
      fullPath: '/operations/'
      preLoaderRoute: typeof OperationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/': {
      id: '/marketing/'
      path: '/marketing'
      fullPath: '/marketing/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/': {
      id: '/learn/'
      path: '/learn'
      fullPath: '/learn/'
      preLoaderRoute: typeof LearnIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hermes/': {
      id: '/hermes/'
      path: '/'
      fullPath: '/hermes/'
      preLoaderRoute: typeof HermesIndexRouteImport
      parentRoute: typeof HermesRouteRoute
    }
    '/finance/': {
      id: '/finance/'
      path: '/'
      fullPath: '/finance/'
      preLoaderRoute: typeof FinanceIndexRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/events/': {
      id: '/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof EventsRoute
    }
    '/diagnostics/': {
      id: '/diagnostics/'
      path: '/diagnostics'
      fullPath: '/diagnostics/'
      preLoaderRoute: typeof DiagnosticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnostic/': {
      id: '/diagnostic/'
      path: '/'
      fullPath: '/diagnostic/'
      preLoaderRoute: typeof DiagnosticIndexRouteImport
      parentRoute: typeof DiagnosticRoute
    }
    '/crm/': {
      id: '/crm/'
      path: '/crm'
      fullPath: '/crm/'
      preLoaderRoute: typeof CrmIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community/': {
      id: '/community/'
      path: '/community'
      fullPath: '/community/'
      preLoaderRoute: typeof CommunityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coaching/': {
      id: '/coaching/'
      path: '/coaching'
      fullPath: '/coaching/'
      preLoaderRoute: typeof CoachingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/': {
      id: '/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/author/': {
      id: '/author/'
      path: '/author'
      fullPath: '/author/'
      preLoaderRoute: typeof AuthorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/': {
      id: '/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AssetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alfie/': {
      id: '/alfie/'
      path: '/alfie'
      fullPath: '/alfie/'
      preLoaderRoute: typeof AlfieIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/tracking/reports': {
      id: '/tracking/reports'
      path: '/tracking/reports'
      fullPath: '/tracking/reports'
      preLoaderRoute: typeof TrackingReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracking/lead-lag': {
      id: '/tracking/lead-lag'
      path: '/tracking/lead-lag'
      fullPath: '/tracking/lead-lag'
      preLoaderRoute: typeof TrackingLeadLagRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/skills': {
      id: '/team/skills'
      path: '/team/skills'
      fullPath: '/team/skills'
      preLoaderRoute: typeof TeamSkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/roles': {
      id: '/team/roles'
      path: '/team/roles'
      fullPath: '/team/roles'
      preLoaderRoute: typeof TeamRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/hr': {
      id: '/team/hr'
      path: '/team/hr'
      fullPath: '/team/hr'
      preLoaderRoute: typeof TeamHrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/directory': {
      id: '/team/directory'
      path: '/team/directory'
      fullPath: '/team/directory'
      preLoaderRoute: typeof TeamDirectoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/culture': {
      id: '/team/culture'
      path: '/team/culture'
      fullPath: '/team/culture'
      preLoaderRoute: typeof TeamCultureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategy/business-plan': {
      id: '/strategy/business-plan'
      path: '/strategy/business-plan'
      fullPath: '/strategy/business-plan'
      preLoaderRoute: typeof StrategyBusinessPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategy/architecture': {
      id: '/strategy/architecture'
      path: '/strategy/architecture'
      fullPath: '/strategy/architecture'
      preLoaderRoute: typeof StrategyArchitectureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recording/$recordingId': {
      id: '/recording/$recordingId'
      path: '/recording/$recordingId'
      fullPath: '/recording/$recordingId'
      preLoaderRoute: typeof RecordingRecordingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$slug': {
      id: '/org/$slug'
      path: '/org/$slug'
      fullPath: '/org/$slug'
      preLoaderRoute: typeof OrgSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/systems': {
      id: '/operations/systems'
      path: '/operations/systems'
      fullPath: '/operations/systems'
      preLoaderRoute: typeof OperationsSystemsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/policies': {
      id: '/operations/policies'
      path: '/operations/policies'
      fullPath: '/operations/policies'
      preLoaderRoute: typeof OperationsPoliciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/compliance': {
      id: '/operations/compliance'
      path: '/operations/compliance'
      fullPath: '/operations/compliance'
      preLoaderRoute: typeof OperationsComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mastermind/$mastermindId': {
      id: '/mastermind/$mastermindId'
      path: '/mastermind/$mastermindId'
      fullPath: '/mastermind/$mastermindId'
      preLoaderRoute: typeof MastermindMastermindIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/social': {
      id: '/marketing/social'
      path: '/marketing/social'
      fullPath: '/marketing/social'
      preLoaderRoute: typeof MarketingSocialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/sales': {
      id: '/marketing/sales'
      path: '/marketing/sales'
      fullPath: '/marketing/sales'
      preLoaderRoute: typeof MarketingSalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/content': {
      id: '/marketing/content'
      path: '/marketing/content'
      fullPath: '/marketing/content'
      preLoaderRoute: typeof MarketingContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/gamified': {
      id: '/learn/gamified'
      path: '/learn/gamified'
      fullPath: '/learn/gamified'
      preLoaderRoute: typeof LearnGamifiedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/accept': {
      id: '/invitations/accept'
      path: '/invitations/accept'
      fullPath: '/invitations/accept'
      preLoaderRoute: typeof InvitationsAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hermes/executions': {
      id: '/hermes/executions'
      path: '/executions'
      fullPath: '/hermes/executions'
      preLoaderRoute: typeof HermesExecutionsRouteImport
      parentRoute: typeof HermesRouteRoute
    }
    '/hermes/dlq': {
      id: '/hermes/dlq'
      path: '/dlq'
      fullPath: '/hermes/dlq'
      preLoaderRoute: typeof HermesDlqRouteImport
      parentRoute: typeof HermesRouteRoute
    }
    '/hermes/definitions': {
      id: '/hermes/definitions'
      path: '/definitions'
      fullPath: '/hermes/definitions'
      preLoaderRoute: typeof HermesDefinitionsRouteImport
      parentRoute: typeof HermesRouteRoute
    }
    '/hermes/builder': {
      id: '/hermes/builder'
      path: '/builder'
      fullPath: '/hermes/builder'
      preLoaderRoute: typeof HermesBuilderRouteImport
      parentRoute: typeof HermesRouteRoute
    }
    '/finance/scorecard': {
      id: '/finance/scorecard'
      path: '/scorecard'
      fullPath: '/finance/scorecard'
      preLoaderRoute: typeof FinanceScorecardRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/scenarios': {
      id: '/finance/scenarios'
      path: '/scenarios'
      fullPath: '/finance/scenarios'
      preLoaderRoute: typeof FinanceScenariosRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/reports': {
      id: '/finance/reports'
      path: '/reports'
      fullPath: '/finance/reports'
      preLoaderRoute: typeof FinanceReportsRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/profit': {
      id: '/finance/profit'
      path: '/profit'
      fullPath: '/finance/profit'
      preLoaderRoute: typeof FinanceProfitRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast': {
      id: '/finance/forecast'
      path: '/forecast'
      fullPath: '/finance/forecast'
      preLoaderRoute: typeof FinanceForecastRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/data': {
      id: '/finance/data'
      path: '/data'
      fullPath: '/finance/data'
      preLoaderRoute: typeof FinanceDataRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/dashboards': {
      id: '/finance/dashboards'
      path: '/dashboards'
      fullPath: '/finance/dashboards'
      preLoaderRoute: typeof FinanceDashboardsRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/cashflow': {
      id: '/finance/cashflow'
      path: '/cashflow'
      fullPath: '/finance/cashflow'
      preLoaderRoute: typeof FinanceCashflowRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/budget': {
      id: '/finance/budget'
      path: '/budget'
      fullPath: '/finance/budget'
      preLoaderRoute: typeof FinanceBudgetRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof EventsRoute
    }
    '/diagnostics/prime-path': {
      id: '/diagnostics/prime-path'
      path: '/diagnostics/prime-path'
      fullPath: '/diagnostics/prime-path'
      preLoaderRoute: typeof DiagnosticsPrimePathRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnostics/leadership': {
      id: '/diagnostics/leadership'
      path: '/diagnostics/leadership'
      fullPath: '/diagnostics/leadership'
      preLoaderRoute: typeof DiagnosticsLeadershipRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnostics/gap-analysis': {
      id: '/diagnostics/gap-analysis'
      path: '/diagnostics/gap-analysis'
      fullPath: '/diagnostics/gap-analysis'
      preLoaderRoute: typeof DiagnosticsGapAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnostic/roadmap': {
      id: '/diagnostic/roadmap'
      path: '/roadmap'
      fullPath: '/diagnostic/roadmap'
      preLoaderRoute: typeof DiagnosticRoadmapRouteImport
      parentRoute: typeof DiagnosticRoute
    }
    '/diagnostic/results': {
      id: '/diagnostic/results'
      path: '/results'
      fullPath: '/diagnostic/results'
      preLoaderRoute: typeof DiagnosticResultsRouteImport
      parentRoute: typeof DiagnosticRoute
    }
    '/diagnostic/history': {
      id: '/diagnostic/history'
      path: '/history'
      fullPath: '/diagnostic/history'
      preLoaderRoute: typeof DiagnosticHistoryRouteImport
      parentRoute: typeof DiagnosticRoute
    }
    '/crm/projects': {
      id: '/crm/projects'
      path: '/crm/projects'
      fullPath: '/crm/projects'
      preLoaderRoute: typeof CrmProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm/deals': {
      id: '/crm/deals'
      path: '/crm/deals'
      fullPath: '/crm/deals'
      preLoaderRoute: typeof CrmDealsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm/contacts': {
      id: '/crm/contacts'
      path: '/crm/contacts'
      fullPath: '/crm/contacts'
      preLoaderRoute: typeof CrmContactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community/leaderboard': {
      id: '/community/leaderboard'
      path: '/community/leaderboard'
      fullPath: '/community/leaderboard'
      preLoaderRoute: typeof CommunityLeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coaching/directory': {
      id: '/coaching/directory'
      path: '/coaching/directory'
      fullPath: '/coaching/directory'
      preLoaderRoute: typeof CoachingDirectoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coaching/book': {
      id: '/coaching/book'
      path: '/coaching/book'
      fullPath: '/coaching/book'
      preLoaderRoute: typeof CoachingBookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/confirm': {
      id: '/auth/confirm'
      path: '/auth/confirm'
      fullPath: '/auth/confirm'
      preLoaderRoute: typeof AuthConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/templates': {
      id: '/assets/templates'
      path: '/assets/templates'
      fullPath: '/assets/templates'
      preLoaderRoute: typeof AssetsTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/apps': {
      id: '/assets/apps'
      path: '/assets/apps'
      fullPath: '/assets/apps'
      preLoaderRoute: typeof AssetsAppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/docs': {
      id: '/api/docs'
      path: '/api/docs'
      fullPath: '/api/docs'
      preLoaderRoute: typeof ApiDocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alfie/settings': {
      id: '/alfie/settings'
      path: '/alfie/settings'
      fullPath: '/alfie/settings'
      preLoaderRoute: typeof AlfieSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alfie/insights': {
      id: '/alfie/insights'
      path: '/alfie/insights'
      fullPath: '/alfie/insights'
      preLoaderRoute: typeof AlfieInsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alfie/agent': {
      id: '/alfie/agent'
      path: '/alfie/agent'
      fullPath: '/alfie/agent'
      preLoaderRoute: typeof AlfieAgentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tier-settings': {
      id: '/admin/tier-settings'
      path: '/tier-settings'
      fullPath: '/admin/tier-settings'
      preLoaderRoute: typeof AdminTierSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/surveys': {
      id: '/admin/surveys'
      path: '/surveys'
      fullPath: '/admin/surveys'
      preLoaderRoute: typeof AdminSurveysRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/subscriptions': {
      id: '/admin/subscriptions'
      path: '/subscriptions'
      fullPath: '/admin/subscriptions'
      preLoaderRoute: typeof AdminSubscriptionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/speedies': {
      id: '/admin/speedies'
      path: '/speedies'
      fullPath: '/admin/speedies'
      preLoaderRoute: typeof AdminSpeediesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/signup-codes': {
      id: '/admin/signup-codes'
      path: '/signup-codes'
      fullPath: '/admin/signup-codes'
      preLoaderRoute: typeof AdminSignupCodesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/security': {
      id: '/admin/security'
      path: '/security'
      fullPath: '/admin/security'
      preLoaderRoute: typeof AdminSecurityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sales': {
      id: '/admin/sales'
      path: '/sales'
      fullPath: '/admin/sales'
      preLoaderRoute: typeof AdminSalesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/revenue': {
      id: '/admin/revenue'
      path: '/revenue'
      fullPath: '/admin/revenue'
      preLoaderRoute: typeof AdminRevenueRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/push-diagnostics': {
      id: '/admin/push-diagnostics'
      path: '/push-diagnostics'
      fullPath: '/admin/push-diagnostics'
      preLoaderRoute: typeof AdminPushDiagnosticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/onboarding-questions': {
      id: '/admin/onboarding-questions'
      path: '/onboarding-questions'
      fullPath: '/admin/onboarding-questions'
      preLoaderRoute: typeof AdminOnboardingQuestionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/mentorship': {
      id: '/admin/mentorship'
      path: '/mentorship'
      fullPath: '/admin/mentorship'
      preLoaderRoute: typeof AdminMentorshipRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/integrations': {
      id: '/admin/integrations'
      path: '/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AdminIntegrationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/import-sync': {
      id: '/admin/import-sync'
      path: '/import-sync'
      fullPath: '/admin/import-sync'
      preLoaderRoute: typeof AdminImportSyncRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/free-courses': {
      id: '/admin/free-courses'
      path: '/free-courses'
      fullPath: '/admin/free-courses'
      preLoaderRoute: typeof AdminFreeCoursesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/flags': {
      id: '/admin/flags'
      path: '/flags'
      fullPath: '/admin/flags'
      preLoaderRoute: typeof AdminFlagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/event-purchases': {
      id: '/admin/event-purchases'
      path: '/event-purchases'
      fullPath: '/admin/event-purchases'
      preLoaderRoute: typeof AdminEventPurchasesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/developer': {
      id: '/admin/developer'
      path: '/developer'
      fullPath: '/admin/developer'
      preLoaderRoute: typeof AdminDeveloperRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/communities': {
      id: '/admin/communities'
      path: '/communities'
      fullPath: '/admin/communities'
      preLoaderRoute: typeof AdminCommunitiesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/avatar-check': {
      id: '/admin/avatar-check'
      path: '/avatar-check'
      fullPath: '/admin/avatar-check'
      preLoaderRoute: typeof AdminAvatarCheckRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/allowed-signups': {
      id: '/admin/allowed-signups'
      path: '/allowed-signups'
      fullPath: '/admin/allowed-signups'
      preLoaderRoute: typeof AdminAllowedSignupsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ai-usage': {
      id: '/admin/ai-usage'
      path: '/ai-usage'
      fullPath: '/admin/ai-usage'
      preLoaderRoute: typeof AdminAiUsageRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/access-requests': {
      id: '/admin/access-requests'
      path: '/access-requests'
      fullPath: '/admin/access-requests'
      preLoaderRoute: typeof AdminAccessRequestsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/access': {
      id: '/admin/access'
      path: '/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof AdminAccessRouteImport
      parentRoute: typeof AdminRoute
    }
    '/learn/courses/': {
      id: '/learn/courses/'
      path: '/learn/courses'
      fullPath: '/learn/courses/'
      preLoaderRoute: typeof LearnCoursesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/certificates/': {
      id: '/learn/certificates/'
      path: '/learn/certificates'
      fullPath: '/learn/certificates/'
      preLoaderRoute: typeof LearnCertificatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/$assetId/': {
      id: '/assets/$assetId/'
      path: '/assets/$assetId'
      fullPath: '/assets/$assetId/'
      preLoaderRoute: typeof AssetsAssetIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings/$source/$id': {
      id: '/recordings/$source/$id'
      path: '/recordings/$source/$id'
      fullPath: '/recordings/$source/$id'
      preLoaderRoute: typeof RecordingsSourceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/paths/$pathId': {
      id: '/learn/paths/$pathId'
      path: '/learn/paths/$pathId'
      fullPath: '/learn/paths/$pathId'
      preLoaderRoute: typeof LearnPathsPathIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/courses/$courseId': {
      id: '/learn/courses/$courseId'
      path: '/learn/courses/$courseId'
      fullPath: '/learn/courses/$courseId'
      preLoaderRoute: typeof LearnCoursesCourseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/assessments/$assessmentId': {
      id: '/learn/assessments/$assessmentId'
      path: '/learn/assessments/$assessmentId'
      fullPath: '/learn/assessments/$assessmentId'
      preLoaderRoute: typeof LearnAssessmentsAssessmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hermes/executions_/$executionId': {
      id: '/hermes/executions_/$executionId'
      path: '/executions/$executionId'
      fullPath: '/hermes/executions/$executionId'
      preLoaderRoute: typeof HermesExecutionsExecutionIdRouteImport
      parentRoute: typeof HermesRouteRoute
    }
    '/finance/xero/mapping': {
      id: '/finance/xero/mapping'
      path: '/xero/mapping'
      fullPath: '/finance/xero/mapping'
      preLoaderRoute: typeof FinanceXeroMappingRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/xero/connect': {
      id: '/finance/xero/connect'
      path: '/xero/connect'
      fullPath: '/finance/xero/connect'
      preLoaderRoute: typeof FinanceXeroConnectRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/what-if-scenarios': {
      id: '/finance/forecast_/what-if-scenarios'
      path: '/forecast/what-if-scenarios'
      fullPath: '/finance/forecast/what-if-scenarios'
      preLoaderRoute: typeof FinanceForecastWhatIfScenariosRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/staff-mix': {
      id: '/finance/forecast_/staff-mix'
      path: '/forecast/staff-mix'
      fullPath: '/finance/forecast/staff-mix'
      preLoaderRoute: typeof FinanceForecastStaffMixRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/project-pricing': {
      id: '/finance/forecast_/project-pricing'
      path: '/forecast/project-pricing'
      fullPath: '/finance/forecast/project-pricing'
      preLoaderRoute: typeof FinanceForecastProjectPricingRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/profit-first': {
      id: '/finance/forecast_/profit-first'
      path: '/forecast/profit-first'
      fullPath: '/finance/forecast/profit-first'
      preLoaderRoute: typeof FinanceForecastProfitFirstRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/overhead-recovery': {
      id: '/finance/forecast_/overhead-recovery'
      path: '/forecast/overhead-recovery'
      fullPath: '/finance/forecast/overhead-recovery'
      preLoaderRoute: typeof FinanceForecastOverheadRecoveryRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/gp-per-hour': {
      id: '/finance/forecast_/gp-per-hour'
      path: '/forecast/gp-per-hour'
      fullPath: '/finance/forecast/gp-per-hour'
      preLoaderRoute: typeof FinanceForecastGpPerHourRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/financial-freedom': {
      id: '/finance/forecast_/financial-freedom'
      path: '/forecast/financial-freedom'
      fullPath: '/finance/forecast/financial-freedom'
      preLoaderRoute: typeof FinanceForecastFinancialFreedomRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/budget-vs-actual': {
      id: '/finance/forecast_/budget-vs-actual'
      path: '/forecast/budget-vs-actual'
      fullPath: '/finance/forecast/budget-vs-actual'
      preLoaderRoute: typeof FinanceForecastBudgetVsActualRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/13-week-cashflow': {
      id: '/finance/forecast_/13-week-cashflow'
      path: '/forecast/13-week-cashflow'
      fullPath: '/finance/forecast/13-week-cashflow'
      preLoaderRoute: typeof FinanceForecast13WeekCashflowRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/forecast_/12-month-pl': {
      id: '/finance/forecast_/12-month-pl'
      path: '/forecast/12-month-pl'
      fullPath: '/finance/forecast/12-month-pl'
      preLoaderRoute: typeof FinanceForecast12MonthPlRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/finance/dashboards_/$dashboardId': {
      id: '/finance/dashboards_/$dashboardId'
      path: '/dashboards/$dashboardId'
      fullPath: '/finance/dashboards/$dashboardId'
      preLoaderRoute: typeof FinanceDashboardsDashboardIdRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/community/post/$postId': {
      id: '/community/post/$postId'
      path: '/community/post/$postId'
      fullPath: '/community/post/$postId'
      preLoaderRoute: typeof CommunityPostPostIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users_/$userId': {
      id: '/admin/users_/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/signup-codes_/$code': {
      id: '/admin/signup-codes_/$code'
      path: '/signup-codes/$code'
      fullPath: '/admin/signup-codes/$code'
      preLoaderRoute: typeof AdminSignupCodesCodeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/diagnostic/settings': {
      id: '/admin/diagnostic/settings'
      path: '/diagnostic/settings'
      fullPath: '/admin/diagnostic/settings'
      preLoaderRoute: typeof AdminDiagnosticSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/diagnostic/questions': {
      id: '/admin/diagnostic/questions'
      path: '/diagnostic/questions'
      fullPath: '/admin/diagnostic/questions'
      preLoaderRoute: typeof AdminDiagnosticQuestionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/diagnostic/inspect': {
      id: '/admin/diagnostic/inspect'
      path: '/diagnostic/inspect'
      fullPath: '/admin/diagnostic/inspect'
      preLoaderRoute: typeof AdminDiagnosticInspectRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/diagnostic/import-export': {
      id: '/admin/diagnostic/import-export'
      path: '/diagnostic/import-export'
      fullPath: '/admin/diagnostic/import-export'
      preLoaderRoute: typeof AdminDiagnosticImportExportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/diagnostic/guardrails': {
      id: '/admin/diagnostic/guardrails'
      path: '/diagnostic/guardrails'
      fullPath: '/admin/diagnostic/guardrails'
      preLoaderRoute: typeof AdminDiagnosticGuardrailsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/communities_/new': {
      id: '/admin/communities_/new'
      path: '/communities/new'
      fullPath: '/admin/communities/new'
      preLoaderRoute: typeof AdminCommunitiesNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/communities_/$communityId': {
      id: '/admin/communities_/$communityId'
      path: '/communities/$communityId'
      fullPath: '/admin/communities/$communityId'
      preLoaderRoute: typeof AdminCommunitiesCommunityIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/learn/courses/$courseId/': {
      id: '/learn/courses/$courseId/'
      path: '/'
      fullPath: '/learn/courses/$courseId/'
      preLoaderRoute: typeof LearnCoursesCourseIdIndexRouteImport
      parentRoute: typeof LearnCoursesCourseIdRoute
    }
    '/author/courses/$courseId/edit': {
      id: '/author/courses/$courseId/edit'
      path: '/author/courses/$courseId/edit'
      fullPath: '/author/courses/$courseId/edit'
      preLoaderRoute: typeof AuthorCoursesCourseIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/author/assessments/$assessmentId/edit': {
      id: '/author/assessments/$assessmentId/edit'
      path: '/author/assessments/$assessmentId/edit'
      fullPath: '/author/assessments/$assessmentId/edit'
      preLoaderRoute: typeof AuthorAssessmentsAssessmentIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/diagnostic/questions/$id': {
      id: '/admin/diagnostic/questions/$id'
      path: '/$id'
      fullPath: '/admin/diagnostic/questions/$id'
      preLoaderRoute: typeof AdminDiagnosticQuestionsIdRouteImport
      parentRoute: typeof AdminDiagnosticQuestionsRoute
    }
    '/learn/courses/$courseId/lessons/$lessonId': {
      id: '/learn/courses/$courseId/lessons/$lessonId'
      path: '/lessons/$lessonId'
      fullPath: '/learn/courses/$courseId/lessons/$lessonId'
      preLoaderRoute: typeof LearnCoursesCourseIdLessonsLessonIdRouteImport
      parentRoute: typeof LearnCoursesCourseIdRoute
    }
    '/admin/diagnostic/questions/$id/test': {
      id: '/admin/diagnostic/questions/$id/test'
      path: '/test'
      fullPath: '/admin/diagnostic/questions/$id/test'
      preLoaderRoute: typeof AdminDiagnosticQuestionsIdTestRouteImport
      parentRoute: typeof AdminDiagnosticQuestionsIdRoute
    }
  }
}

interface FinanceRouteRouteChildren {
  FinanceBudgetRoute: typeof FinanceBudgetRoute
  FinanceCashflowRoute: typeof FinanceCashflowRoute
  FinanceDashboardsRoute: typeof FinanceDashboardsRoute
  FinanceDataRoute: typeof FinanceDataRoute
  FinanceForecastRoute: typeof FinanceForecastRoute
  FinanceProfitRoute: typeof FinanceProfitRoute
  FinanceReportsRoute: typeof FinanceReportsRoute
  FinanceScenariosRoute: typeof FinanceScenariosRoute
  FinanceScorecardRoute: typeof FinanceScorecardRoute
  FinanceIndexRoute: typeof FinanceIndexRoute
  FinanceDashboardsDashboardIdRoute: typeof FinanceDashboardsDashboardIdRoute
  FinanceForecast12MonthPlRoute: typeof FinanceForecast12MonthPlRoute
  FinanceForecast13WeekCashflowRoute: typeof FinanceForecast13WeekCashflowRoute
  FinanceForecastBudgetVsActualRoute: typeof FinanceForecastBudgetVsActualRoute
  FinanceForecastFinancialFreedomRoute: typeof FinanceForecastFinancialFreedomRoute
  FinanceForecastGpPerHourRoute: typeof FinanceForecastGpPerHourRoute
  FinanceForecastOverheadRecoveryRoute: typeof FinanceForecastOverheadRecoveryRoute
  FinanceForecastProfitFirstRoute: typeof FinanceForecastProfitFirstRoute
  FinanceForecastProjectPricingRoute: typeof FinanceForecastProjectPricingRoute
  FinanceForecastStaffMixRoute: typeof FinanceForecastStaffMixRoute
  FinanceForecastWhatIfScenariosRoute: typeof FinanceForecastWhatIfScenariosRoute
  FinanceXeroConnectRoute: typeof FinanceXeroConnectRoute
  FinanceXeroMappingRoute: typeof FinanceXeroMappingRoute
}

const FinanceRouteRouteChildren: FinanceRouteRouteChildren = {
  FinanceBudgetRoute: FinanceBudgetRoute,
  FinanceCashflowRoute: FinanceCashflowRoute,
  FinanceDashboardsRoute: FinanceDashboardsRoute,
  FinanceDataRoute: FinanceDataRoute,
  FinanceForecastRoute: FinanceForecastRoute,
  FinanceProfitRoute: FinanceProfitRoute,
  FinanceReportsRoute: FinanceReportsRoute,
  FinanceScenariosRoute: FinanceScenariosRoute,
  FinanceScorecardRoute: FinanceScorecardRoute,
  FinanceIndexRoute: FinanceIndexRoute,
  FinanceDashboardsDashboardIdRoute: FinanceDashboardsDashboardIdRoute,
  FinanceForecast12MonthPlRoute: FinanceForecast12MonthPlRoute,
  FinanceForecast13WeekCashflowRoute: FinanceForecast13WeekCashflowRoute,
  FinanceForecastBudgetVsActualRoute: FinanceForecastBudgetVsActualRoute,
  FinanceForecastFinancialFreedomRoute: FinanceForecastFinancialFreedomRoute,
  FinanceForecastGpPerHourRoute: FinanceForecastGpPerHourRoute,
  FinanceForecastOverheadRecoveryRoute: FinanceForecastOverheadRecoveryRoute,
  FinanceForecastProfitFirstRoute: FinanceForecastProfitFirstRoute,
  FinanceForecastProjectPricingRoute: FinanceForecastProjectPricingRoute,
  FinanceForecastStaffMixRoute: FinanceForecastStaffMixRoute,
  FinanceForecastWhatIfScenariosRoute: FinanceForecastWhatIfScenariosRoute,
  FinanceXeroConnectRoute: FinanceXeroConnectRoute,
  FinanceXeroMappingRoute: FinanceXeroMappingRoute,
}

const FinanceRouteRouteWithChildren = FinanceRouteRoute._addFileChildren(
  FinanceRouteRouteChildren,
)

interface HermesRouteRouteChildren {
  HermesBuilderRoute: typeof HermesBuilderRoute
  HermesDefinitionsRoute: typeof HermesDefinitionsRoute
  HermesDlqRoute: typeof HermesDlqRoute
  HermesExecutionsRoute: typeof HermesExecutionsRoute
  HermesIndexRoute: typeof HermesIndexRoute
  HermesExecutionsExecutionIdRoute: typeof HermesExecutionsExecutionIdRoute
}

const HermesRouteRouteChildren: HermesRouteRouteChildren = {
  HermesBuilderRoute: HermesBuilderRoute,
  HermesDefinitionsRoute: HermesDefinitionsRoute,
  HermesDlqRoute: HermesDlqRoute,
  HermesExecutionsRoute: HermesExecutionsRoute,
  HermesIndexRoute: HermesIndexRoute,
  HermesExecutionsExecutionIdRoute: HermesExecutionsExecutionIdRoute,
}

const HermesRouteRouteWithChildren = HermesRouteRoute._addFileChildren(
  HermesRouteRouteChildren,
)

interface AdminDiagnosticQuestionsIdRouteChildren {
  AdminDiagnosticQuestionsIdTestRoute: typeof AdminDiagnosticQuestionsIdTestRoute
}

const AdminDiagnosticQuestionsIdRouteChildren: AdminDiagnosticQuestionsIdRouteChildren =
  {
    AdminDiagnosticQuestionsIdTestRoute: AdminDiagnosticQuestionsIdTestRoute,
  }

const AdminDiagnosticQuestionsIdRouteWithChildren =
  AdminDiagnosticQuestionsIdRoute._addFileChildren(
    AdminDiagnosticQuestionsIdRouteChildren,
  )

interface AdminDiagnosticQuestionsRouteChildren {
  AdminDiagnosticQuestionsIdRoute: typeof AdminDiagnosticQuestionsIdRouteWithChildren
}

const AdminDiagnosticQuestionsRouteChildren: AdminDiagnosticQuestionsRouteChildren =
  {
    AdminDiagnosticQuestionsIdRoute:
      AdminDiagnosticQuestionsIdRouteWithChildren,
  }

const AdminDiagnosticQuestionsRouteWithChildren =
  AdminDiagnosticQuestionsRoute._addFileChildren(
    AdminDiagnosticQuestionsRouteChildren,
  )

interface AdminRouteChildren {
  AdminAccessRoute: typeof AdminAccessRoute
  AdminAccessRequestsRoute: typeof AdminAccessRequestsRoute
  AdminAiUsageRoute: typeof AdminAiUsageRoute
  AdminAllowedSignupsRoute: typeof AdminAllowedSignupsRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminAvatarCheckRoute: typeof AdminAvatarCheckRoute
  AdminCommunitiesRoute: typeof AdminCommunitiesRoute
  AdminDeveloperRoute: typeof AdminDeveloperRoute
  AdminEventPurchasesRoute: typeof AdminEventPurchasesRoute
  AdminFlagsRoute: typeof AdminFlagsRoute
  AdminFreeCoursesRoute: typeof AdminFreeCoursesRoute
  AdminImportSyncRoute: typeof AdminImportSyncRoute
  AdminIntegrationsRoute: typeof AdminIntegrationsRoute
  AdminMentorshipRoute: typeof AdminMentorshipRoute
  AdminOnboardingQuestionsRoute: typeof AdminOnboardingQuestionsRoute
  AdminPushDiagnosticsRoute: typeof AdminPushDiagnosticsRoute
  AdminRevenueRoute: typeof AdminRevenueRoute
  AdminSalesRoute: typeof AdminSalesRoute
  AdminSecurityRoute: typeof AdminSecurityRoute
  AdminSignupCodesRoute: typeof AdminSignupCodesRoute
  AdminSpeediesRoute: typeof AdminSpeediesRoute
  AdminSubscriptionsRoute: typeof AdminSubscriptionsRoute
  AdminSurveysRoute: typeof AdminSurveysRoute
  AdminTierSettingsRoute: typeof AdminTierSettingsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCommunitiesCommunityIdRoute: typeof AdminCommunitiesCommunityIdRoute
  AdminCommunitiesNewRoute: typeof AdminCommunitiesNewRoute
  AdminDiagnosticGuardrailsRoute: typeof AdminDiagnosticGuardrailsRoute
  AdminDiagnosticImportExportRoute: typeof AdminDiagnosticImportExportRoute
  AdminDiagnosticInspectRoute: typeof AdminDiagnosticInspectRoute
  AdminDiagnosticQuestionsRoute: typeof AdminDiagnosticQuestionsRouteWithChildren
  AdminDiagnosticSettingsRoute: typeof AdminDiagnosticSettingsRoute
  AdminSignupCodesCodeRoute: typeof AdminSignupCodesCodeRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAccessRoute: AdminAccessRoute,
  AdminAccessRequestsRoute: AdminAccessRequestsRoute,
  AdminAiUsageRoute: AdminAiUsageRoute,
  AdminAllowedSignupsRoute: AdminAllowedSignupsRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminAvatarCheckRoute: AdminAvatarCheckRoute,
  AdminCommunitiesRoute: AdminCommunitiesRoute,
  AdminDeveloperRoute: AdminDeveloperRoute,
  AdminEventPurchasesRoute: AdminEventPurchasesRoute,
  AdminFlagsRoute: AdminFlagsRoute,
  AdminFreeCoursesRoute: AdminFreeCoursesRoute,
  AdminImportSyncRoute: AdminImportSyncRoute,
  AdminIntegrationsRoute: AdminIntegrationsRoute,
  AdminMentorshipRoute: AdminMentorshipRoute,
  AdminOnboardingQuestionsRoute: AdminOnboardingQuestionsRoute,
  AdminPushDiagnosticsRoute: AdminPushDiagnosticsRoute,
  AdminRevenueRoute: AdminRevenueRoute,
  AdminSalesRoute: AdminSalesRoute,
  AdminSecurityRoute: AdminSecurityRoute,
  AdminSignupCodesRoute: AdminSignupCodesRoute,
  AdminSpeediesRoute: AdminSpeediesRoute,
  AdminSubscriptionsRoute: AdminSubscriptionsRoute,
  AdminSurveysRoute: AdminSurveysRoute,
  AdminTierSettingsRoute: AdminTierSettingsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCommunitiesCommunityIdRoute: AdminCommunitiesCommunityIdRoute,
  AdminCommunitiesNewRoute: AdminCommunitiesNewRoute,
  AdminDiagnosticGuardrailsRoute: AdminDiagnosticGuardrailsRoute,
  AdminDiagnosticImportExportRoute: AdminDiagnosticImportExportRoute,
  AdminDiagnosticInspectRoute: AdminDiagnosticInspectRoute,
  AdminDiagnosticQuestionsRoute: AdminDiagnosticQuestionsRouteWithChildren,
  AdminDiagnosticSettingsRoute: AdminDiagnosticSettingsRoute,
  AdminSignupCodesCodeRoute: AdminSignupCodesCodeRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DiagnosticRouteChildren {
  DiagnosticHistoryRoute: typeof DiagnosticHistoryRoute
  DiagnosticResultsRoute: typeof DiagnosticResultsRoute
  DiagnosticRoadmapRoute: typeof DiagnosticRoadmapRoute
  DiagnosticIndexRoute: typeof DiagnosticIndexRoute
}

const DiagnosticRouteChildren: DiagnosticRouteChildren = {
  DiagnosticHistoryRoute: DiagnosticHistoryRoute,
  DiagnosticResultsRoute: DiagnosticResultsRoute,
  DiagnosticRoadmapRoute: DiagnosticRoadmapRoute,
  DiagnosticIndexRoute: DiagnosticIndexRoute,
}

const DiagnosticRouteWithChildren = DiagnosticRoute._addFileChildren(
  DiagnosticRouteChildren,
)

interface EventsRouteChildren {
  EventsEventIdRoute: typeof EventsEventIdRoute
  EventsIndexRoute: typeof EventsIndexRoute
}

const EventsRouteChildren: EventsRouteChildren = {
  EventsEventIdRoute: EventsEventIdRoute,
  EventsIndexRoute: EventsIndexRoute,
}

const EventsRouteWithChildren =
  EventsRoute._addFileChildren(EventsRouteChildren)

interface LearnCoursesCourseIdRouteChildren {
  LearnCoursesCourseIdIndexRoute: typeof LearnCoursesCourseIdIndexRoute
  LearnCoursesCourseIdLessonsLessonIdRoute: typeof LearnCoursesCourseIdLessonsLessonIdRoute
}

const LearnCoursesCourseIdRouteChildren: LearnCoursesCourseIdRouteChildren = {
  LearnCoursesCourseIdIndexRoute: LearnCoursesCourseIdIndexRoute,
  LearnCoursesCourseIdLessonsLessonIdRoute:
    LearnCoursesCourseIdLessonsLessonIdRoute,
}

const LearnCoursesCourseIdRouteWithChildren =
  LearnCoursesCourseIdRoute._addFileChildren(LearnCoursesCourseIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FinanceRouteRoute: FinanceRouteRouteWithChildren,
  HermesRouteRoute: HermesRouteRouteWithChildren,
  Access_matrixRoute: Access_matrixRoute,
  AdminRoute: AdminRouteWithChildren,
  CheckoutRoute: CheckoutRoute,
  DataDeletionRoute: DataDeletionRoute,
  DiagnosticRoute: DiagnosticRouteWithChildren,
  DiagnosticAdminRoute: DiagnosticAdminRoute,
  EventsRoute: EventsRouteWithChildren,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  MyWorkRoute: MyWorkRoute,
  OnboardingRoute: OnboardingRoute,
  PlanRoute: PlanRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RsvpRoute: RsvpRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  StreamsRoute: StreamsRoute,
  TermsRoute: TermsRoute,
  TimelineRoute: TimelineRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  VerifyRoute: VerifyRoute,
  AlfieAgentRoute: AlfieAgentRoute,
  AlfieInsightsRoute: AlfieInsightsRoute,
  AlfieSettingsRoute: AlfieSettingsRoute,
  ApiDocsRoute: ApiDocsRoute,
  AssetsAppsRoute: AssetsAppsRoute,
  AssetsTemplatesRoute: AssetsTemplatesRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthConfirmRoute: AuthConfirmRoute,
  CoachingBookRoute: CoachingBookRoute,
  CoachingDirectoryRoute: CoachingDirectoryRoute,
  CommunityLeaderboardRoute: CommunityLeaderboardRoute,
  CrmContactsRoute: CrmContactsRoute,
  CrmDealsRoute: CrmDealsRoute,
  CrmProjectsRoute: CrmProjectsRoute,
  DiagnosticsGapAnalysisRoute: DiagnosticsGapAnalysisRoute,
  DiagnosticsLeadershipRoute: DiagnosticsLeadershipRoute,
  DiagnosticsPrimePathRoute: DiagnosticsPrimePathRoute,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
  LearnGamifiedRoute: LearnGamifiedRoute,
  MarketingContentRoute: MarketingContentRoute,
  MarketingSalesRoute: MarketingSalesRoute,
  MarketingSocialRoute: MarketingSocialRoute,
  MastermindMastermindIdRoute: MastermindMastermindIdRoute,
  OperationsComplianceRoute: OperationsComplianceRoute,
  OperationsPoliciesRoute: OperationsPoliciesRoute,
  OperationsSystemsRoute: OperationsSystemsRoute,
  OrgSlugRoute: OrgSlugRoute,
  RecordingRecordingIdRoute: RecordingRecordingIdRoute,
  StrategyArchitectureRoute: StrategyArchitectureRoute,
  StrategyBusinessPlanRoute: StrategyBusinessPlanRoute,
  TeamCultureRoute: TeamCultureRoute,
  TeamDirectoryRoute: TeamDirectoryRoute,
  TeamHrRoute: TeamHrRoute,
  TeamRolesRoute: TeamRolesRoute,
  TeamSkillsRoute: TeamSkillsRoute,
  TrackingLeadLagRoute: TrackingLeadLagRoute,
  TrackingReportsRoute: TrackingReportsRoute,
  AlfieIndexRoute: AlfieIndexRoute,
  AssetsIndexRoute: AssetsIndexRoute,
  AuthorIndexRoute: AuthorIndexRoute,
  ChatIndexRoute: ChatIndexRoute,
  CoachingIndexRoute: CoachingIndexRoute,
  CommunityIndexRoute: CommunityIndexRoute,
  CrmIndexRoute: CrmIndexRoute,
  DiagnosticsIndexRoute: DiagnosticsIndexRoute,
  LearnIndexRoute: LearnIndexRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  OperationsIndexRoute: OperationsIndexRoute,
  RecordingsIndexRoute: RecordingsIndexRoute,
  StrategyIndexRoute: StrategyIndexRoute,
  TeamIndexRoute: TeamIndexRoute,
  TrackingIndexRoute: TrackingIndexRoute,
  CommunityPostPostIdRoute: CommunityPostPostIdRoute,
  LearnAssessmentsAssessmentIdRoute: LearnAssessmentsAssessmentIdRoute,
  LearnCoursesCourseIdRoute: LearnCoursesCourseIdRouteWithChildren,
  LearnPathsPathIdRoute: LearnPathsPathIdRoute,
  RecordingsSourceIdRoute: RecordingsSourceIdRoute,
  AssetsAssetIdIndexRoute: AssetsAssetIdIndexRoute,
  LearnCertificatesIndexRoute: LearnCertificatesIndexRoute,
  LearnCoursesIndexRoute: LearnCoursesIndexRoute,
  AuthorAssessmentsAssessmentIdEditRoute:
    AuthorAssessmentsAssessmentIdEditRoute,
  AuthorCoursesCourseIdEditRoute: AuthorCoursesCourseIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
